<template>
    <div class="energyOverview app-bg">
    <div id="base" class="">

      

      <!-- Unnamed (Rectangle) -->
      <div id="u3098" class="ax_default box_1">
        <div id="u3098_div" class=""></div>
        <div id="u3098_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3099" class="ax_default box_1">
        <div id="u3099_div" class=""></div>
        <div id="u3099_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3100" class="ax_default button" @click="setFlag1(1)">
        <div id="u3100_div" class=""></div>
        <div id="u3100_text" class="text ">
          <p><span>月</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3101" class="ax_default button" @click="setFlag1(2)">
        <div id="u3101_div" class=""></div>
        <div id="u3101_text" class="text ">
          <p><span>季</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u3102" class="ax_default line">
        <img id="u3102_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u3102_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3103" class="ax_default button" @click="setFlag1(3)">
        <div id="u3103_div" class=""></div>
        <div id="u3103_text" class="text ">
          <p><span>年</span></p>
        </div>
      </div>



      <!-- Unnamed (Group) -->
      <div id="u3105" class="ax_default" data-left="258" data-top="953" data-width="1149" data-height="203">

        <!-- Unnamed (Rectangle) -->
        <div id="u3106" class="ax_default label">
          <div id="u3106_div" class=""></div>
          <div id="u3106_text" class="text ">
            <p><span>节能目标详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3107" class="ax_default box_1">
          <div id="u3107_div" class=""></div>
          <div id="u3107_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3108" class="ax_default label">
          <div id="u3108_div" class=""></div>
          <div id="u3108_text" class="text ">
            <p><span>能耗类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u3109" class="ax_default droplist">
          <div id="u3109_div" class=""></div>
          <select id="u3109_input" class="u3109_input" v-model="queryParams.energyType">
            <option class="u3109_input_option" selected value="">请选择</option>
            <option class="u3109_input_option" value="1">用电</option>
            <option class="u3109_input_option" value="2">用水</option>
            <option class="u3109_input_option" value="3">用气</option>
            <option class="u3109_input_option" value="4">用热</option>
            <option class="u3109_input_option" value="5">其他能源</option>
          </select>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3110" class="ax_default label">
          <div id="u3110_div" class=""></div>
          <div id="u3110_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3111" class="ax_default image">
           <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              value-format="yyyy-MM-dd HH:mm:ss"
               v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                   @change="setDateRange"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
          
          <div id="u3111_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3112" class="ax_default primary_button" @click="handleQuery"> 
          <div id="u3112_div" class=""></div>
          <div id="u3112_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
          <div id="u3113" class="ax_default box_1">
           
              <div class="innerbox"  style="width: 100%; height:350px;position: absolute;
z-index: 99;">
                <el-table  :data="consumptionlist"  v-loading="loading"
                style="width: 100%;"
                 show-header="false"
                >
         
                <el-table-column label="时间" align="center" prop="energyMonth" />
                <el-table-column label="能耗类型" align="center" prop="energyType" />
                <el-table-column label="目标节能" align="center" prop="goal" />
                <el-table-column label="实际节能" align="center" prop="savingrate" />
                 <el-table-column label="目标完成度" align="center" prop="completion" />
               
             </el-table>
            
                <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
         
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3114" class="ax_default heading_1">
          <div id="u3114_div" class=""></div>
          <div id="u3114_text" class="text ">
            <p><span>能耗类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Line) -->
        <div id="u3115" class="ax_default _水平线">
          <img id="u3115_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u396.svg"/>
          <div id="u3115_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3116" class="ax_default heading_1">
          <div id="u3116_div" class=""></div>
          <div id="u3116_text" class="text ">
            <p><span style="font-family:'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;font-weight:700;">时间</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3117" class="ax_default primary_button">
          <div id="u3117_div" class=""></div>
          <div id="u3117_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3118" class="ax_default label">
          <div id="u3118_div" class=""></div>
          <div id="u3118_text" class="text ">
            <p><span>暂无数据</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3119" class="ax_default box_1">
          <div id="u3119_div" class=""></div>
          <div id="u3119_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3120" class="ax_default heading_1">
          <div id="u3120_div" class=""></div>
          <div id="u3120_text" class="text ">
            <p><span>目标节能</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3121" class="ax_default heading_1">
          <div id="u3121_div" class=""></div>
          <div id="u3121_text" class="text ">
            <p><span>实际节能</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3122" class="ax_default heading_1">
          <div id="u3122_div" class=""></div>
          <div id="u3122_text" class="text ">
            <p><span>目标完成度</span></p>
          </div>
        </div>
      </div>
 <div id="u31261" class="ax_default button" >
            <el-radio-group v-model="radio" @change="getChange">
    <el-radio :label="0">总目标</el-radio>
    <el-radio :label="1">用电</el-radio>
    <el-radio :label="2">用水</el-radio>
    <el-radio :label="3">用气</el-radio>
     <el-radio :label="4">用热</el-radio>
    <el-radio :label="5">其他能源</el-radio>
  </el-radio-group>
  </div>
 
      <!-- Unnamed (Rectangle) -->
      <div id="u3131" class="ax_default box_1">
        <div id="u3131_div" class=""></div>
        <div id="u3131_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3132" class="ax_default" data-left="276" data-top="201" data-width="1120" data-height="698">
        <!-- <div id="u3132_div"></div> -->

        <!-- Unnamed (Rectangle) -->
        <div id="u3133" class="ax_default box_1">
          <div id="u3133_div" class=""></div>
          <div id="u3133_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Line) -->
        <div id="u3134" class="ax_default line">
          <img id="u3134_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u338.svg"/>
          <div id="u3134_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3135" class="ax_default label">
          <div id="u3135_div" class=""></div>
          <div id="u3135_text" class="text ">
            <p><span>月度节能&amp;完成度评价&amp;预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3136" class="ax_default box_1">
          <div id="u3136_div" class=""></div>
          <div id="u3136_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3137" class="ax_default box_1">
          <div id="u3137_div" class=""></div>
          <div id="u3137_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3138" class="ax_default heading_1">
          <div id="u3138_div" class=""></div>
          <div id="u3138_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3139" class="ax_default box_1">
          <div id="u3139_div" class=""></div>
          <div id="u3139_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Group) -->
        <div id="u3140" class="ax_default" data-left="1084" data-top="255" data-width="303" data-height="628">
        
          <div id="u3146" class="ax_default label">
            <div id="u3146_div" class=""></div>
            <div id="u3146_text" class="text ">
              <p><span>完成度评价</span></p>
            </div>
          </div>
   <div id="u3147" class="ax_default image">
            <!-- <img id="u3865_img" class="img " src="../../../../../../assets/common/quota/icon/month/u1741.png"/> -->
            <div id="u3865_text" class="text " style="display:none; visibility: hidden">
              <p></p>
            </div>
          </div>
     
            <div id="u31401" class="ax_default">
           
            <table>
           
              <tr width="300" v-for='item in tableData' :key='item.date'>
                <td  width="100" height="29">{{item.date}}</td>
                <td  width="100" height="29">{{item.name}}</td>
                 <td  width="100" v-if="item.name==='优秀'">
                  <img  src="../../../../../../assets/common/performanc/icon/month/u3153.png" class="img" width="31" height="29">
                  </td>
                  <td  width="100" v-if="item.name==='良好'">
                  <img  src="../../../../../../assets/common/performanc/icon/month/u3154.png" class="img" width="31" height="29">
                  </td>
                   <td  width="100" v-if="item.name==='加油'">
                  <img  src="../../../../../../assets/common/performanc/icon/month/u3152.png" class="img" width="31" height="29">
                  </td>
                </tr>
            
                </table>
                
            </div>
        </div>

        <!-- Unnamed (Group) -->
        <div id="u3165" class="ax_default" data-left="288" data-top="776" data-width="779" data-height="94">

          <!-- Unnamed (Rectangle) -->
          <div id="u3166" class="ax_default box_1">
            <div id="u3166_div" class=""></div>
            <div id="u3166_text" class="text " style="display:none; visibility: hidden">
              <p></p>
            </div>
          </div>

         

          <!-- Unnamed (Rectangle) 表头-->
          <div id="u3169" class="ax_default box_1">
  
            <el-table
              :data="rightsDate"     
                border
                
                width="100%"
                height="95%"
                class="customer-table"
                :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                >
              <el-table-column
                  v-for="info in rightHeader" :key="info.key"     

                  :property="info.key"
                  :label="info.label"
                >
             <template slot-scope="scope">
                   {{scope.row[scope.column.property]}}  
              </template>
              </el-table-column>
   
              </el-table>
            </div>
          </div>

             
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3182" class="ax_default label">
          <div id="u3182_div" class=""></div>
          <div id="u3182_text" class="text ">
            <p><span>目标预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3183" class="ax_default image">
           <v-chart
            ref="lineChart"
            style="width: 100%;height:330px"
            :options="monthlyProportionOptionsRate"
            theme="macarons"
            :auto-resize="true"
          ></v-chart>
         <div id="u3183_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
        </div>

      </div>

    

      <!-- Unnamed (Rectangle) -->
      <div id="u3185" class="ax_default label">
        <div id="u3185_div" class=""></div>
        <!-- <div id="u3185_text" class="text ">
          <p><span style="font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;">分区</span><span style="font-family:'ArialMT', 'Arial', sans-serif;">&amp;</span><span style="font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;">分项节能详情</span></p>
        </div> -->
      </div>


    </div>

    
 

</template>
<script>
import "echarts/theme/macarons";
import {
  getPerformancLevel1,//总汇总
  listLevel1,//总查询列表
 
} from "@/api/business/energy/performanc";
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
     components: {Pagination},
  data() {
    return {
         flag:1,
           radio: 0,
       list: null,
      
        // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   energyType: '',
               
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
      monthAnalysis:[],
      yearlyAnalysis:[],
      seasonAnalysis:[],
      energyTypeList: [
        { itemCode: 1, itemName: "电力" },
        { itemCode: 2, itemName: "水" },
        { itemCode: 3, itemName: "天然气" },
        { itemCode: 4, itemName: "热力" },
        { itemCode: 5, itemName: "其他能源" },
      ],

      electricityProportionOptions: null,
      monthlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      monthlyProportionOptionsRate2: null,
      monthlyProportionOptionsRate3: null,
      seasonProportionOptions: null,
      seasonProportionOptionsRate: null,
      seasonProportionOptionsRate2: null,
      seasonProportionOptionsRate3: null,
      yearlyProportionOptions: null,
      yearlyProportionOptionsRate: null,
      yearlyProportionOptionsRate2: null,
      yearlyProportionOptionsRate3: null,
      montharr: [],//月份
      montharr2: [],//月份
      dataarr: [],//目标值
      dataarr2: [],//实际值
      dataarr3: [],//预测值
      dataarr4: [],//评价
      forcastdata:null,
      rightHeader: [],
      rightsDate: [],
       tableData: [],
       besturl: "../../../../../../assets/common/performanc/icon/month/u3153.png",
       betterurl: "../../../../../../assets/common/performanc/icon/month/u3154.png",
       goodurl: "../../../../../../assets/common/performanc/icon/month/u3152.png",

      performancLevel1VO: {
        //----------汇总年数据-------------
    //今年总节能目标
    powerYear: "",//1
    waterYear: "",//2
    gasYear: "",//3
    hotYear: "",//4
    othersYear: "",//5
    totalYear: "",//0

    //---今年总节能完成度评价
    powerCompletionYear: "",
    waterCompletionYear: "",
    gasCompletionYear: "",
    hotCompletionYear: "",
    othersCompletionYear: "",
    totalCompletionYear: "",

    //---今年实际完成率
    powerSavingRateYear: "",
    waterSavingRateYear: "",
    gasSavingRateYear: "",
    hotSavingRateYear: "",
    otherschangeRateYear: "",
    totalSavingRateYear: "",

    //--下一周期预测
    powerForecastYear: "",
    waterForecastYear: "",
    gasForecastYear: "",
    hotForecastYear: "",
    othersForecastYear: "",
    totalForecastYear: "",
    //----------------汇总季-----------------------------
    //电
    totalSeason1: "",
    totalSeason2: "",
    totalSeason3: "",
    totalSeason4: "",


    //---季度节能完成度评价
    totalCompletionSeason1: "",
    totalCompletionSeason2: "",
    totalCompletionSeason3: "",
    totalCompletionSeason4: "",

    //---季用完成率
    totalSavingRateSeason1: "",
    totalSavingRateSeason2: "",
    totalSavingRateSeason3: "",
    totalSavingRateSeason4: "",

    //--季下一周期预测
    totalForecastSeason1: "",
    totalForecastSeason2: "",
    totalForecastSeason3: "",
    totalForecastSeason4: "",

    //----------------电-----------------------------
    //电季
    powerSeason1: "",
    powerSeason2: "",
    powerSeason3: "",
    powerSeason4: "",


    //---季度节能完成度评价
    powerCompletionSeason1: "",
    powerCompletionSeason2: "",
    powerCompletionSeason3: "",
    powerCompletionSeason4: "",

    //---季用节能率
    powerSavingRateSeason1: "",
    powerSavingRateSeason2: "",
    powerSavingRateSeason3: "",
    powerSavingRateSeason4: "",

    //--季下一周期预测
    powerForecastSeason1: "",
    powerForecastSeason2: "",
    powerForecastSeason3: "",
    powerForecastSeason4: "",


    //---------------水----------------------------------------

    //水季
    waterSeason1: "",
    waterSeason2: "",
    waterSeason3: "",
    waterSeason4: "",
    //---季度节能完成度评价
    waterCompletionSeason1: "",
    waterCompletionSeason2: "",
    waterCompletionSeason3: "",
    waterCompletionSeason4: "",

    //---季节能完成率
    waterSavingRateSeason1: "",
    waterSavingRateSeason2: "",
    waterSavingRateSeason3: "",
    waterSavingRateSeason4: "",

    //--水季下一周期预测
    waterForecastSeason1: "",
    waterForecastSeason2: "",
    waterForecastSeason3: "",
    waterForecastSeason4: "",

    //--------------气--------------------------------------
    //气
    gasSeason1: "",
    gasSeason2: "",
    gasSeason3: "",
    gasSeason4: "",
    //---季度节能完成度评价
    gasCompletionSeason1: "",
    gasCompletionSeason2: "",
    gasCompletionSeason3: "",
    gasCompletionSeason4: "",
    //---季节能完成率
    gasSavingRateSeason1: "",
    gasSavingRateSeason2: "",
    gasSavingRateSeason3: "",
    gasSavingRateSeason4: "",

    //--气下一周期预测
    gasForecastSeason1: "",
    gasForecastSeason2: "",
    gasForecastSeason3: "",
    gasForecastSeason4: "",

    //--------------热-----------------------------
    //热
    hotSeason1: "",
    hotSeason2: "",
    hotSeason3: "",
    hotSeason4: "",
    //---季度节能完成度评价
    hotCompletionSeason1: "",
    hotCompletionSeason2: "",
    hotCompletionSeason3: "",
    hotCompletionSeason4: "",
    //---季节能完成率
    hotSavingRateSeason1: "",
    hotSavingRateSeason2: "",
    hotSavingRateSeason3: "",
    hotSavingRateSeason4: "",

    //--热季下一周期预测
    hotForecastSeason1: "",
    hotForecastSeason2: "",
    hotForecastSeason3: "",
    hotForecastSeason4: "",
    //----------------其他-----------------------------
    //其他
    othersSeason1: "",
    othersSeason2: "",
    othersSeason3: "",
    othersSeason4: "",


    //---季度节能完成度评价
    othersCompletionSeason1: "",
    othersCompletionSeason2: "",
    othersCompletionSeason3: "",
    othersCompletionSeason4: "",

    //---季节能完成率
    othersSavingRateSeason1: "",
    othersSavingRateSeason2: "",
    othersSavingRateSeason3: "",
    othersSavingRateSeason4: "",

    //--季下一周期预测
    othersForecastSeason1: "",
    othersForecastSeason2: "",
    othersForecastSeason3: "",
    othersForecastSeason4: "",
    //---------------总节能月----
    //总节能
    totalMonth1: "",
    totalMonth2: "",
    totalMonth3: "",
    totalMonth4: "",
    totalMonth5: "",
    totalMonth6: "",
    totalMonth7: "",
    totalMonth8: "",
    totalMonth9: "",
    totalMonth10: "",
    totalMonth11: "",
    totalMonth12: "",

    //总节能完成度评价
    totalCompletionMonth1: "",
    totalCompletionMonth2: "",
    totalCompletionMonth3: "",
    totalCompletionMonth4: "",
    totalCompletionMonth5: "",
    totalCompletionMonth6: "",
    totalCompletionMonth7: "",
    totalCompletionMonth8: "",
    totalCompletionMonth9: "",
    totalCompletionMonth10: "",
    totalCompletionMonth11: "",
    totalCompletionMonth12: "",
    //---总节能完成率
    totalSavingRateMonth1: "",
    totalSavingRateMonth2: "",
    totalSavingRateMonth3: "",
    totalSavingRateMonth4: "",
    totalSavingRateMonth5: "",
    totalSavingRateMonth6: "",
    totalSavingRateMonth7: "",
    totalSavingRateMonth8: "",
    totalSavingRateMonth9: "",
    totalSavingRateMonth10: "",
    totalSavingRateMonth11: "",
    totalSavingRateMonth12: "",


    //--总下一周期预测
    totalForecastMonth1: "",
    totalForecastMonth2: "",
    totalForecastMonth3: "",
    totalForecastMonth4: "",
    totalForecastMonth5: "",
    totalForecastMonth6: "",
    totalForecastMonth7: "",
    totalForecastMonth8: "",
    totalForecastMonth9: "",
    totalForecastMonth10: "",
    totalForecastMonth11: "",
    totalForecastMonth12: "",

    //-------------电月----------------------------
    //电
    powerMonth1: "",
    powerMonth2: "",
    powerMonth3: "",
    powerMonth4: "",
    powerMonth5: "",
    powerMonth6: "",
    powerMonth7: "",
    powerMonth8: "",
    powerMonth9: "",
    powerMonth10: "",
    powerMonth11: "",
    powerMonth12: "",

    //电节能完成度评价
    powerCompletionMonth1: "",
    powerCompletionMonth2: "",
    powerCompletionMonth3: "",
    powerCompletionMonth4: "",
    powerCompletionMonth5: "",
    powerCompletionMonth6: "",
    powerCompletionMonth7: "",
    powerCompletionMonth8: "",
    powerCompletionMonth9: "",
    powerCompletionMonth10: "",
    powerCompletionMonth11: "",
    powerCompletionMonth12: "",
    //---月节能完成率
    powerSavingRateMonth1: "",
    powerSavingRateMonth2: "",
    powerSavingRateMonth3: "",
    powerSavingRateMonth4: "",
    powerSavingRateMonth5: "",
    powerSavingRateMonth6: "",
    powerSavingRateMonth7: "",
    powerSavingRateMonth8: "",
    powerSavingRateMonth9: "",
    powerSavingRateMonth10: "",
    powerSavingRateMonth11: "",
    powerSavingRateMonth12: "",


    //--月下一周期预测
    powerForecastMonth1: "",
    powerForecastMonth2: "",
    powerForecastMonth3: "",
    powerForecastMonth4: "",
    powerForecastMonth5: "",
    powerForecastMonth6: "",
    powerForecastMonth7: "",
    powerForecastMonth8: "",
    powerForecastMonth9: "",
    powerForecastMonth10: "",
    powerForecastMonth11: "",
    powerForecastMonth12: "",
    //--------------------
    //--------------------------水----------------------------
    waterMonth1: "",
    waterMonth2: "",
    waterMonth3: "",
    waterMonth4: "",
    waterMonth5: "",
    waterMonth6: "",
    waterMonth7: "",
    waterMonth8: "",
    waterMonth9: "",
    waterMonth10: "",
    waterMonth11: "",
    waterMonth12: "",
    //水节能完成度评价
    waterCompletionMonth1: "",
    waterCompletionMonth2: "",
    waterCompletionMonth3: "",
    waterCompletionMonth4: "",
    waterCompletionMonth5: "",
    waterCompletionMonth6: "",
    waterCompletionMonth7: "",
    waterCompletionMonth8: "",
    waterCompletionMonth9: "",
    waterCompletionMonth10: "",
    waterCompletionMonth11: "",
    waterCompletionMonth12: "",
    //---月节能完成率
    waterSavingRateMonth1: "",
    waterSavingRateMonth2: "",
    waterSavingRateMonth3: "",
    waterSavingRateMonth4: "",
    waterSavingRateMonth5: "",
    waterSavingRateMonth6: "",
    waterSavingRateMonth7: "",
    waterSavingRateMonth8: "",
    waterSavingRateMonth9: "",
    waterSavingRateMonth10: "",
    waterSavingRateMonth11: "",
    waterSavingRateMonth12: "",

    //--月下一周期预测
    waterForecastMonth1: "",
    waterForecastMonth2: "",
    waterForecastMonth3: "",
    waterForecastMonth4: "",
    waterForecastMonth5: "",
    waterForecastMonth6: "",
    waterForecastMonth7: "",
    waterForecastMonth8: "",
    waterForecastMonth9: "",
    waterForecastMonth10: "",
    waterForecastMonth11: "",
    waterForecastMonth12: "",
    //-------------------------气------------------------
    gasMonth1: "",
    gasMonth2: "",
    gasMonth3: "",
    gasMonth4: "",
    gasMonth5: "",
    gasMonth6: "",
    gasMonth7: "",
    gasMonth8: "",
    gasMonth9: "",
    gasMonth10: "",
    gasMonth11: "",
    gasMonth12: "",
    //气节能完成度评价
    gasCompletionMonth1: "",
    gasCompletionMonth2: "",
    gasCompletionMonth3: "",
    gasCompletionMonth4: "",
    gasCompletionMonth5: "",
    gasCompletionMonth6: "",
    gasCompletionMonth7: "",
    gasCompletionMonth8: "",
    gasCompletionMonth9: "",
    gasCompletionMonth10: "",
    gasCompletionMonth11: "",
    gasCompletionMonth12: "",
    //---月节能完成率
    gasSavingRateMonth1: "",
    gasSavingRateMonth2: "",
    gasSavingRateMonth3: "",
    gasSavingRateMonth4: "",
    gasSavingRateMonth5: "",
    gasSavingRateMonth6: "",
    gasSavingRateMonth7: "",
    gasSavingRateMonth8: "",
    gasSavingRateMonth9: "",
    gasSavingRateMonth10: "",
    gasSavingRateMonth11: "",
    gasSavingRateMonth12: "",

    //--月下一周期预测
    gasForecastMonth1: "",
    gasForecastMonth2: "",
    gasForecastMonth3: "",
    gasForecastMonth4: "",
    gasForecastMonth5: "",
    gasForecastMonth6: "",
    gasForecastMonth7: "",
    gasForecastMonth8: "",
    gasForecastMonth9: "",
    gasForecastMonth10: "",
    gasForecastMonth11: "",
    gasForecastMonth12: "",

    //--------------------热-------------------------------
    hotMonth1: "",
    hotMonth2: "",
    hotMonth3: "",
    hotMonth4: "",
    hotMonth5: "",
    hotMonth6: "",
    hotMonth7: "",
    hotMonth8: "",
    hotMonth9: "",
    hotMonth10: "",
    hotMonth11: "",
    hotMonth12: "",
    //热节能完成度评价
    hotCompletionMonth1: "",
    hotCompletionMonth2: "",
    hotCompletionMonth3: "",
    hotCompletionMonth4: "",
    hotCompletionMonth5: "",
    hotCompletionMonth6: "",
    hotCompletionMonth7: "",
    hotCompletionMonth8: "",
    hotCompletionMonth9: "",
    hotCompletionMonth10: "",
    hotCompletionMonth11: "",
    hotCompletionMonth12: "",
    //---月节能完成率
    hotSavingRateMonth1: "",
    hotSavingRateMonth2: "",
    hotSavingRateMonth3: "",
    hotSavingRateMonth4: "",
    hotSavingRateMonth5: "",
    hotSavingRateMonth6: "",
    hotSavingRateMonth7: "",
    hotSavingRateMonth8: "",
    hotSavingRateMonth9: "",
    hotSavingRateMonth10: "",
    hotSavingRateMonth11: "",
    hotSavingRateMonth12: "",


    //--月下一周期预测
    hotForecastMonth1: "",
    hotForecastMonth2: "",
    hotForecastMonth3: "",
    hotForecastMonth4: "",
    hotForecastMonth5: "",
    hotForecastMonth6: "",
    hotForecastMonth7: "",
    hotForecastMonth8: "",
    hotForecastMonth9: "",
    hotForecastMonth10: "",
    hotForecastMonth11: "",
    hotForecastMonth12: "",
    //--------------------------------------其他----

    othersMonth1: "",
    othersMonth2: "",
    othersMonth3: "",
    othersMonth4: "",
    othersMonth5: "",
    othersMonth6: "",
    othersMonth7: "",
    othersMonth8: "",
    othersMonth9: "",
    othersMonth10: "",
    othersMonth11: "",
    othersMonth12: "",

    //其他节能完成度评价
    othersCompletionMonth1: "",
    othersCompletionMonth2: "",
    othersCompletionMonth3: "",
    othersCompletionMonth4: "",
    othersCompletionMonth5: "",
    othersCompletionMonth6: "",
    othersCompletionMonth7: "",
    othersCompletionMonth8: "",
    othersCompletionMonth9: "",
    othersCompletionMonth10: "",
    othersCompletionMonth11: "",
    othersCompletionMonth12: "",
    //---其他节能完成率
    othersSavingRateMonth1: "",
    othersSavingRateMonth2: "",
    othersSavingRateMonth3: "",
    othersSavingRateMonth4: "",
    othersSavingRateMonth5: "",
    othersSavingRateMonth6: "",
    othersSavingRateMonth7: "",
    othersSavingRateMonth8: "",
    othersSavingRateMonth9: "",
    othersSavingRateMonth10: "",
    othersSavingRateMonth11: "",
    othersSavingRateMonth12: "",


    //--其他下一周期预测
    othersForecastMonth1: "",
    othersForecastMonth2: "",
    othersForecastMonth3: "",
    othersForecastMonth4: "",
    othersForecastMonth5: "",
    othersForecastMonth6: "",
    othersForecastMonth7: "",
    othersForecastMonth8: "",
    othersForecastMonth9: "",
    othersForecastMonth10: "",
    othersForecastMonth11: "",
    othersForecastMonth12: "",
      }
    };
  },
  created() {
   
    getPerformancLevel1(this.queryParams).then((response) => {
          // alert("11111");
          this.performancLevel1VO = response.data;
 
 
        //------------------
               //年报
    // this.monthlyProportionOptions = this.monthlyProportion();
     this.monthlyProportionOptionsRate = this.monthlyProportionRate(0);
    // this.monthlyProportionOptionsRate3 = this.monthlyProportionRate3();
    //    //季报
   
    // this.seasonProportionOptions = this.seasonProportion();
    // this.seasonProportionOptionsRate = this.seasonProportionRate();
    //  this.seasonProportionOptionsRate3 = this.seasonProportionRate3(); 
       //月报
   // this.yearlyProportionOptions = this.yearlyProportion(); 
    //this.yearlyProportionOptionsRate = this.yearlyProportionRate();
    //this.yearlyProportionOptionsRate3 = this.yearlyProportionRate3();
        //--------------
        
         });
    
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
      /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;

      listLevel1(this.queryParams).then((response) => {
     
        for(var i=0;i<response.rows.length;i++){
        
            if(response.rows[i].energyType==1){
               response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
               response.rows[i].energyType='电';
            }
            if(response.rows[i].energyType==2){
              response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='水';}
              if(response.rows[i].energyType==3){
               response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='气';}
            
            if(response.rows[i].energyType==4){
              response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='热';
            }
              if(response.rows[i].energyType==5){
                response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='其他能源'; 
              }
        }
      
        this.consumptionlist = response.rows;
         // alert(this.consumptionlist.length);
        this.total = response.total;
        this.loading = false;
      });
    },
        setDateRange(dateRange) {
        
          //alert(dateRange[0].substr(0,7));
        
         if (dateRange) {
                    this.queryParams.startTime = dateRange[0].substr(0,7);
                    this.queryParams.endTime = dateRange[1].substr(0,7);
                    
          } else {// 清空
                    this.queryParams.startTime = null;
                    this.queryParams.endTime = null;
           }
               
         },
         getChange(typeid){
          
              if(typeid==0){
        // alert(typeid);
          //总月度数据 
  
          this.monthlyProportionOptionsRate = this.monthlyProportionRate(0);
         // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(0);
          
        }
        else if(typeid==1){
        
          //电月度数据 
  
          this.monthlyProportionOptionsRate = this.monthlyProportionRate(1);
          //this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(1);
          
        }else if(typeid==2){
          //水月度数据 
          this.monthlyProportionOptionsRate = this.monthlyProportionRate(2);
          // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(2);
        }else if(typeid==3){
         //气月度数据 
         this.monthlyProportionOptionsRate = this.monthlyProportionRate(3);
          //this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(3);
        }else if(typeid==4){
          //热月度数据 
          this.monthlyProportionOptionsRate = this.monthlyProportionRate(4);
           //this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(4);
        }else if(typeid==5){
         // 其他月度数据 
         this.monthlyProportionOptionsRate = this.monthlyProportionRate(5);
         // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(5);
        }
      },
      //  monthlyProportionRate1(flag){
      //     if(flag==null || flag=="undefined")
      //        flag=0;
      //       //change=this.consumptionLevel1VO.powerChangeMonth1;
      //      // changerate=this.consumptionLevel1VO.powerChangeRateMonth1;
      //      var value="";
      //      var change="";
      //      var changerate="";
          
      //      var date = new Date();
      //      var curmonth=date .getMonth(); 
      //      if(flag==0){
      //        switch(curmonth){
      //           case 0:
      //             this.montharr=["1月"];
      //              this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //              this.dataarr=[this.performancLevel1VO.totalMonth1];//目标值
      //              this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1];//实际值
      //              this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1];//评价
      //              this.dataarr3=[this.performancLevel1VO.totalForecastMonth1,
      //                       this.performancLevel1VO.totalForecastMonth3,
      //                       this.performancLevel1VO.totalForecastMonth4,
      //                       this.performancLevel1VO.totalForecastMonth5,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值
      //                       break;
                  
      //           case 1: 
      //             this. montharr=["1月","2月"];
      //               this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2];//评价
      //                this.dataarr3=[
      //                       this.performancLevel1VO.totalForecastMonth2,
      //                       this.performancLevel1VO.totalForecastMonth4,
      //                       this.performancLevel1VO.totalForecastMonth5,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值
      //                        break;
      //           case 2:
      //              this.montharr=["1月","2月","3月"];        
      //               this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"];  
      //                 this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3];//评价
      //                this.dataarr3=[
                            
      //                       this.performancLevel1VO.totalForecastMonth3,
      //                       this.performancLevel1VO.totalForecastMonth5,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值  
      //                         break;
      //           case 3:
      //              this.montharr=["1月","2月","3月","4月"];
      //               this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3,
      //                         this.performancLevel1VO.totalMonth4];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3,
      //                          this.performancLevel1VO.totalSavingRateMonth4];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3,
      //                          this.performancLevel1VO.totalCompletionMonth4];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.totalForecastMonth4,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 4:
      //                this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3,
      //                         this.performancLevel1VO.totalMonth4,
      //                            this.performancLevel1VO.totalMonth5,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3,
      //                          this.performancLevel1VO.totalSavingRateMonth4,
      //                           this.performancLevel1VO.totalSavingRateMonth5,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3,
      //                          this.performancLevel1VO.totalCompletionMonth4,
      //                            this.performancLevel1VO.totalCompletionMonth5,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.totalForecastMonth5,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 5:
      //               this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3,
      //                         this.performancLevel1VO.totalMonth4,
      //                            this.performancLevel1VO.totalMonth5,
      //                              this.performancLevel1VO.totalMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3,
      //                          this.performancLevel1VO.totalSavingRateMonth4,
      //                           this.performancLevel1VO.totalSavingRateMonth5,
      //                            this.performancLevel1VO.totalSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3,
      //                          this.performancLevel1VO.totalCompletionMonth4,
      //                            this.performancLevel1VO.totalCompletionMonth5,
      //                               this.performancLevel1VO.totalCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 6:
      //                this.montharr=["1月","2月","3月","4月","5月","6月"];
      //               this.montharr2=["7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3,
      //                         this.performancLevel1VO.totalMonth4,
      //                            this.performancLevel1VO.totalMonth5,
      //                              this.performancLevel1VO.totalMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3,
      //                          this.performancLevel1VO.totalSavingRateMonth4,
      //                           this.performancLevel1VO.totalSavingRateMonth5,
      //                            this.performancLevel1VO.totalSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3,
      //                          this.performancLevel1VO.totalCompletionMonth4,
      //                            this.performancLevel1VO.totalCompletionMonth5,
      //                               this.performancLevel1VO.totalCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 7: 
      //              this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
      //               this.montharr2=["8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3,
      //                         this.performancLevel1VO.totalMonth4,
      //                            this.performancLevel1VO.totalMonth5,
      //                              this.performancLevel1VO.totalMonth6,
      //                               this.performancLevel1VO.totalMonth7,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3,
      //                          this.performancLevel1VO.totalSavingRateMonth4,
      //                           this.performancLevel1VO.totalSavingRateMonth5,
      //                            this.performancLevel1VO.totalSavingRateMonth6,
      //                                  this.performancLevel1VO.totalSavingRateMonth7,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3,
      //                          this.performancLevel1VO.totalCompletionMonth4,
      //                            this.performancLevel1VO.totalCompletionMonth5,
      //                               this.performancLevel1VO.totalCompletionMonth6,
      //                                 this.performancLevel1VO.totalCompletionMonth7,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 8:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
      //               this.montharr2=["9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3,
      //                         this.performancLevel1VO.totalMonth4,
      //                            this.performancLevel1VO.totalMonth5,
      //                              this.performancLevel1VO.totalMonth6,
      //                               this.performancLevel1VO.totalMonth7,
      //                                this.performancLevel1VO.totalMonth8,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3,
      //                          this.performancLevel1VO.totalSavingRateMonth4,
      //                           this.performancLevel1VO.totalSavingRateMonth5,
      //                            this.performancLevel1VO.totalSavingRateMonth6,
      //                                  this.performancLevel1VO.totalSavingRateMonth7,
      //                                      this.performancLevel1VO.totalSavingRateMonth8,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3,
      //                          this.performancLevel1VO.totalCompletionMonth4,
      //                            this.performancLevel1VO.totalCompletionMonth5,
      //                               this.performancLevel1VO.totalCompletionMonth6,
      //                                 this.performancLevel1VO.totalCompletionMonth7,
      //                                   this.performancLevel1VO.totalCompletionMonth8,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 9:
      //               this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
      //               this.montharr2=["10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3,
      //                         this.performancLevel1VO.totalMonth4,
      //                            this.performancLevel1VO.totalMonth5,
      //                              this.performancLevel1VO.totalMonth6,
      //                               this.performancLevel1VO.totalMonth7,
      //                                this.performancLevel1VO.totalMonth8,
      //                                    this.performancLevel1VO.totalMonth9,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3,
      //                          this.performancLevel1VO.totalSavingRateMonth4,
      //                           this.performancLevel1VO.totalSavingRateMonth5,
      //                            this.performancLevel1VO.totalSavingRateMonth6,
      //                                  this.performancLevel1VO.totalSavingRateMonth7,
      //                                      this.performancLevel1VO.totalSavingRateMonth8,
      //                                       this.performancLevel1VO.totalSavingRateMonth9,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3,
      //                          this.performancLevel1VO.totalCompletionMonth4,
      //                            this.performancLevel1VO.totalCompletionMonth5,
      //                               this.performancLevel1VO.totalCompletionMonth6,
      //                                 this.performancLevel1VO.totalCompletionMonth7,
      //                                   this.performancLevel1VO.totalCompletionMonth8,
      //                                      this.performancLevel1VO.totalCompletionMonth9,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 10:
      //                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
      //               this.montharr2=["11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3,
      //                         this.performancLevel1VO.totalMonth4,
      //                            this.performancLevel1VO.totalMonth5,
      //                              this.performancLevel1VO.totalMonth6,
      //                               this.performancLevel1VO.totalMonth7,
      //                                this.performancLevel1VO.totalMonth8,
      //                                    this.performancLevel1VO.totalMonth9,
      //                                     this.performancLevel1VO.totalMonth10,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3,
      //                          this.performancLevel1VO.totalSavingRateMonth4,
      //                           this.performancLevel1VO.totalSavingRateMonth5,
      //                            this.performancLevel1VO.totalSavingRateMonth6,
      //                                  this.performancLevel1VO.totalSavingRateMonth7,
      //                                      this.performancLevel1VO.totalSavingRateMonth8,
      //                                       this.performancLevel1VO.totalSavingRateMonth9,
      //                                       this.performancLevel1VO.totalSavingRateMonth10,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3,
      //                          this.performancLevel1VO.totalCompletionMonth4,
      //                            this.performancLevel1VO.totalCompletionMonth5,
      //                               this.performancLevel1VO.totalCompletionMonth6,
      //                                 this.performancLevel1VO.totalCompletionMonth7,
      //                                   this.performancLevel1VO.totalCompletionMonth8,
      //                                      this.performancLevel1VO.totalCompletionMonth9,
      //                                       this.performancLevel1VO.totalCompletionMonth10,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 11:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
      //               this.montharr2=["12月"];
      //                this.dataarr=[this.performancLevel1VO.totalMonth1,
      //                        this.performancLevel1VO.totalMonth2,
      //                        this.performancLevel1VO.totalMonth3,
      //                         this.performancLevel1VO.totalMonth4,
      //                            this.performancLevel1VO.totalMonth5,
      //                              this.performancLevel1VO.totalMonth6,
      //                               this.performancLevel1VO.totalMonth7,
      //                                this.performancLevel1VO.totalMonth8,
      //                                    this.performancLevel1VO.totalMonth9,
      //                                     this.performancLevel1VO.totalMonth10,
      //                                      this.performancLevel1VO.totalMonth11,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
      //                          this.performancLevel1VO.totalSavingRateMonth2,
      //                          this.performancLevel1VO.totalSavingRateMonth3,
      //                          this.performancLevel1VO.totalSavingRateMonth4,
      //                           this.performancLevel1VO.totalSavingRateMonth5,
      //                            this.performancLevel1VO.totalSavingRateMonth6,
      //                                  this.performancLevel1VO.totalSavingRateMonth7,
      //                                      this.performancLevel1VO.totalSavingRateMonth8,
      //                                       this.performancLevel1VO.totalSavingRateMonth9,
      //                                       this.performancLevel1VO.totalSavingRateMonth10,
      //                                       this.performancLevel1VO.totalSavingRateMonth11,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
      //                         this.performancLevel1VO.totalCompletionMonth2,
      //                         this.performancLevel1VO.totalCompletionMonth3,
      //                          this.performancLevel1VO.totalCompletionMonth4,
      //                            this.performancLevel1VO.totalCompletionMonth5,
      //                               this.performancLevel1VO.totalCompletionMonth6,
      //                                 this.performancLevel1VO.totalCompletionMonth7,
      //                                   this.performancLevel1VO.totalCompletionMonth8,
      //                                      this.performancLevel1VO.totalCompletionMonth9,
      //                                       this.performancLevel1VO.totalCompletionMonth10,
      //                                        this.performancLevel1VO.totalCompletionMonth11,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth6,
      //                       this.performancLevel1VO.totalForecastMonth7,
      //                       this.performancLevel1VO.totalForecastMonth8,
      //                       this.performancLevel1VO.totalForecastMonth9,
      //                       this.performancLevel1VO.totalForecastMonth10,
      //                       this.performancLevel1VO.totalForecastMonth11,
      //                       this.performancLevel1VO.totalForecastMonth12,
      //                       ];//预测值   
      //                       break;

      //        }
      //       // dataarr=
      //     }
      //       if(flag==1){
      //        switch(curmonth){
      //           case 0:
      //             this.montharr=["1月"];
      //              this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //              this.dataarr=[this.performancLevel1VO.powerMonth1];//目标值
      //              this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1];//实际值
      //              this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1];//评价
      //              this.dataarr3=[this.performancLevel1VO.powerForecastMonth1,
      //                       this.performancLevel1VO.powerForecastMonth3,
      //                       this.performancLevel1VO.powerForecastMonth4,
      //                       this.performancLevel1VO.powerForecastMonth5,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值
      //                       break;
                  
      //           case 1: 
      //             this. montharr=["1月","2月"];
      //               this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2];//评价
      //                this.dataarr3=[
      //                       this.performancLevel1VO.powerForecastMonth2,
      //                       this.performancLevel1VO.powerForecastMonth4,
      //                       this.performancLevel1VO.powerForecastMonth5,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值
      //                        break;
      //           case 2:
      //              this.montharr=["1月","2月","3月"];        
      //               this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"];  
      //                 this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3];//评价
      //                this.dataarr3=[
                            
      //                       this.performancLevel1VO.powerForecastMonth3,
      //                       this.performancLevel1VO.powerForecastMonth5,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值  
      //                         break;
      //           case 3:
      //              this.montharr=["1月","2月","3月","4月"];
      //               this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3,
      //                         this.performancLevel1VO.powerMonth4];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3,
      //                          this.performancLevel1VO.powerSavingRateMonth4];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3,
      //                          this.performancLevel1VO.powerCompletionMonth4];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.powerForecastMonth4,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 4:
      //                this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3,
      //                         this.performancLevel1VO.powerMonth4,
      //                            this.performancLevel1VO.powerMonth5,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3,
      //                          this.performancLevel1VO.powerSavingRateMonth4,
      //                           this.performancLevel1VO.powerSavingRateMonth5,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3,
      //                          this.performancLevel1VO.powerCompletionMonth4,
      //                            this.performancLevel1VO.powerCompletionMonth5,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.powerForecastMonth5,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 5:
      //               this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3,
      //                         this.performancLevel1VO.powerMonth4,
      //                            this.performancLevel1VO.powerMonth5,
      //                              this.performancLevel1VO.powerMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3,
      //                          this.performancLevel1VO.powerSavingRateMonth4,
      //                           this.performancLevel1VO.powerSavingRateMonth5,
      //                            this.performancLevel1VO.powerSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3,
      //                          this.performancLevel1VO.powerCompletionMonth4,
      //                            this.performancLevel1VO.powerCompletionMonth5,
      //                               this.performancLevel1VO.powerCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 6:
      //                this.montharr=["1月","2月","3月","4月","5月","6月"];
      //               this.montharr2=["7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3,
      //                         this.performancLevel1VO.powerMonth4,
      //                            this.performancLevel1VO.powerMonth5,
      //                              this.performancLevel1VO.powerMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3,
      //                          this.performancLevel1VO.powerSavingRateMonth4,
      //                           this.performancLevel1VO.powerSavingRateMonth5,
      //                            this.performancLevel1VO.powerSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3,
      //                          this.performancLevel1VO.powerCompletionMonth4,
      //                            this.performancLevel1VO.powerCompletionMonth5,
      //                               this.performancLevel1VO.powerCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 7: 
      //              this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
      //               this.montharr2=["8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3,
      //                         this.performancLevel1VO.powerMonth4,
      //                            this.performancLevel1VO.powerMonth5,
      //                              this.performancLevel1VO.powerMonth6,
      //                               this.performancLevel1VO.powerMonth7,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3,
      //                          this.performancLevel1VO.powerSavingRateMonth4,
      //                           this.performancLevel1VO.powerSavingRateMonth5,
      //                            this.performancLevel1VO.powerSavingRateMonth6,
      //                                  this.performancLevel1VO.powerSavingRateMonth7,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3,
      //                          this.performancLevel1VO.powerCompletionMonth4,
      //                            this.performancLevel1VO.powerCompletionMonth5,
      //                               this.performancLevel1VO.powerCompletionMonth6,
      //                                 this.performancLevel1VO.powerCompletionMonth7,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 8:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
      //               this.montharr2=["9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3,
      //                         this.performancLevel1VO.powerMonth4,
      //                            this.performancLevel1VO.powerMonth5,
      //                              this.performancLevel1VO.powerMonth6,
      //                               this.performancLevel1VO.powerMonth7,
      //                                this.performancLevel1VO.powerMonth8,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3,
      //                          this.performancLevel1VO.powerSavingRateMonth4,
      //                           this.performancLevel1VO.powerSavingRateMonth5,
      //                            this.performancLevel1VO.powerSavingRateMonth6,
      //                                  this.performancLevel1VO.powerSavingRateMonth7,
      //                                      this.performancLevel1VO.powerSavingRateMonth8,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3,
      //                          this.performancLevel1VO.powerCompletionMonth4,
      //                            this.performancLevel1VO.powerCompletionMonth5,
      //                               this.performancLevel1VO.powerCompletionMonth6,
      //                                 this.performancLevel1VO.powerCompletionMonth7,
      //                                   this.performancLevel1VO.powerCompletionMonth8,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 9:
      //               this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
      //               this.montharr2=["10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3,
      //                         this.performancLevel1VO.powerMonth4,
      //                            this.performancLevel1VO.powerMonth5,
      //                              this.performancLevel1VO.powerMonth6,
      //                               this.performancLevel1VO.powerMonth7,
      //                                this.performancLevel1VO.powerMonth8,
      //                                    this.performancLevel1VO.powerMonth9,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3,
      //                          this.performancLevel1VO.powerSavingRateMonth4,
      //                           this.performancLevel1VO.powerSavingRateMonth5,
      //                            this.performancLevel1VO.powerSavingRateMonth6,
      //                                  this.performancLevel1VO.powerSavingRateMonth7,
      //                                      this.performancLevel1VO.powerSavingRateMonth8,
      //                                       this.performancLevel1VO.powerSavingRateMonth9,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3,
      //                          this.performancLevel1VO.powerCompletionMonth4,
      //                            this.performancLevel1VO.powerCompletionMonth5,
      //                               this.performancLevel1VO.powerCompletionMonth6,
      //                                 this.performancLevel1VO.powerCompletionMonth7,
      //                                   this.performancLevel1VO.powerCompletionMonth8,
      //                                      this.performancLevel1VO.powerCompletionMonth9,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 10:
      //                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
      //               this.montharr2=["11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3,
      //                         this.performancLevel1VO.powerMonth4,
      //                            this.performancLevel1VO.powerMonth5,
      //                              this.performancLevel1VO.powerMonth6,
      //                               this.performancLevel1VO.powerMonth7,
      //                                this.performancLevel1VO.powerMonth8,
      //                                    this.performancLevel1VO.powerMonth9,
      //                                     this.performancLevel1VO.powerMonth10,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3,
      //                          this.performancLevel1VO.powerSavingRateMonth4,
      //                           this.performancLevel1VO.powerSavingRateMonth5,
      //                            this.performancLevel1VO.powerSavingRateMonth6,
      //                                  this.performancLevel1VO.powerSavingRateMonth7,
      //                                      this.performancLevel1VO.powerSavingRateMonth8,
      //                                       this.performancLevel1VO.powerSavingRateMonth9,
      //                                       this.performancLevel1VO.powerSavingRateMonth10,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3,
      //                          this.performancLevel1VO.powerCompletionMonth4,
      //                            this.performancLevel1VO.powerCompletionMonth5,
      //                               this.performancLevel1VO.powerCompletionMonth6,
      //                                 this.performancLevel1VO.powerCompletionMonth7,
      //                                   this.performancLevel1VO.powerCompletionMonth8,
      //                                      this.performancLevel1VO.powerCompletionMonth9,
      //                                       this.performancLevel1VO.powerCompletionMonth10,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 11:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
      //               this.montharr2=["12月"];
      //                this.dataarr=[this.performancLevel1VO.powerMonth1,
      //                        this.performancLevel1VO.powerMonth2,
      //                        this.performancLevel1VO.powerMonth3,
      //                         this.performancLevel1VO.powerMonth4,
      //                            this.performancLevel1VO.powerMonth5,
      //                              this.performancLevel1VO.powerMonth6,
      //                               this.performancLevel1VO.powerMonth7,
      //                                this.performancLevel1VO.powerMonth8,
      //                                    this.performancLevel1VO.powerMonth9,
      //                                     this.performancLevel1VO.powerMonth10,
      //                                      this.performancLevel1VO.powerMonth11,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
      //                          this.performancLevel1VO.powerSavingRateMonth2,
      //                          this.performancLevel1VO.powerSavingRateMonth3,
      //                          this.performancLevel1VO.powerSavingRateMonth4,
      //                           this.performancLevel1VO.powerSavingRateMonth5,
      //                            this.performancLevel1VO.powerSavingRateMonth6,
      //                                  this.performancLevel1VO.powerSavingRateMonth7,
      //                                      this.performancLevel1VO.powerSavingRateMonth8,
      //                                       this.performancLevel1VO.powerSavingRateMonth9,
      //                                       this.performancLevel1VO.powerSavingRateMonth10,
      //                                       this.performancLevel1VO.powerSavingRateMonth11,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
      //                         this.performancLevel1VO.powerCompletionMonth2,
      //                         this.performancLevel1VO.powerCompletionMonth3,
      //                          this.performancLevel1VO.powerCompletionMonth4,
      //                            this.performancLevel1VO.powerCompletionMonth5,
      //                               this.performancLevel1VO.powerCompletionMonth6,
      //                                 this.performancLevel1VO.powerCompletionMonth7,
      //                                   this.performancLevel1VO.powerCompletionMonth8,
      //                                      this.performancLevel1VO.powerCompletionMonth9,
      //                                       this.performancLevel1VO.powerCompletionMonth10,
      //                                        this.performancLevel1VO.powerCompletionMonth11,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth6,
      //                       this.performancLevel1VO.powerForecastMonth7,
      //                       this.performancLevel1VO.powerForecastMonth8,
      //                       this.performancLevel1VO.powerForecastMonth9,
      //                       this.performancLevel1VO.powerForecastMonth10,
      //                       this.performancLevel1VO.powerForecastMonth11,
      //                       this.performancLevel1VO.powerForecastMonth12,
      //                       ];//预测值   
      //                       break;

      //        }
      //       // dataarr=
      //     }
      //       if(flag==2){
      //        switch(curmonth){
      //           case 0:
      //             this.montharr=["1月"];
      //              this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //              this.dataarr=[this.performancLevel1VO.waterMonth1];//目标值
      //              this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1];//实际值
      //              this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1];//评价
      //              this.dataarr3=[this.performancLevel1VO.waterForecastMonth1,
      //                       this.performancLevel1VO.waterForecastMonth3,
      //                       this.performancLevel1VO.waterForecastMonth4,
      //                       this.performancLevel1VO.waterForecastMonth5,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值
      //                       break;
                  
      //           case 1: 
      //             this. montharr=["1月","2月"];
      //               this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2];//评价
      //                this.dataarr3=[
      //                       this.performancLevel1VO.waterForecastMonth2,
      //                       this.performancLevel1VO.waterForecastMonth4,
      //                       this.performancLevel1VO.waterForecastMonth5,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值
      //                        break;
      //           case 2:
      //              this.montharr=["1月","2月","3月"];        
      //               this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"];  
      //                 this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3];//评价
      //                this.dataarr3=[
                            
      //                       this.performancLevel1VO.waterForecastMonth3,
      //                       this.performancLevel1VO.waterForecastMonth5,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值  
      //                         break;
      //           case 3:
      //              this.montharr=["1月","2月","3月","4月"];
      //               this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3,
      //                         this.performancLevel1VO.waterMonth4];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3,
      //                          this.performancLevel1VO.waterSavingRateMonth4];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3,
      //                          this.performancLevel1VO.waterCompletionMonth4];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.waterForecastMonth4,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 4:
      //                this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3,
      //                         this.performancLevel1VO.waterMonth4,
      //                            this.performancLevel1VO.waterMonth5,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3,
      //                          this.performancLevel1VO.waterSavingRateMonth4,
      //                           this.performancLevel1VO.waterSavingRateMonth5,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3,
      //                          this.performancLevel1VO.waterCompletionMonth4,
      //                            this.performancLevel1VO.waterCompletionMonth5,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.waterForecastMonth5,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 5:
      //               this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3,
      //                         this.performancLevel1VO.waterMonth4,
      //                            this.performancLevel1VO.waterMonth5,
      //                              this.performancLevel1VO.waterMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3,
      //                          this.performancLevel1VO.waterSavingRateMonth4,
      //                           this.performancLevel1VO.waterSavingRateMonth5,
      //                            this.performancLevel1VO.waterSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3,
      //                          this.performancLevel1VO.waterCompletionMonth4,
      //                            this.performancLevel1VO.waterCompletionMonth5,
      //                               this.performancLevel1VO.waterCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 6:
      //                this.montharr=["1月","2月","3月","4月","5月","6月"];
      //               this.montharr2=["7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3,
      //                         this.performancLevel1VO.waterMonth4,
      //                            this.performancLevel1VO.waterMonth5,
      //                              this.performancLevel1VO.waterMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3,
      //                          this.performancLevel1VO.waterSavingRateMonth4,
      //                           this.performancLevel1VO.waterSavingRateMonth5,
      //                            this.performancLevel1VO.waterSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3,
      //                          this.performancLevel1VO.waterCompletionMonth4,
      //                            this.performancLevel1VO.waterCompletionMonth5,
      //                               this.performancLevel1VO.waterCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 7: 
      //              this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
      //               this.montharr2=["8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3,
      //                         this.performancLevel1VO.waterMonth4,
      //                            this.performancLevel1VO.waterMonth5,
      //                              this.performancLevel1VO.waterMonth6,
      //                               this.performancLevel1VO.waterMonth7,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3,
      //                          this.performancLevel1VO.waterSavingRateMonth4,
      //                           this.performancLevel1VO.waterSavingRateMonth5,
      //                            this.performancLevel1VO.waterSavingRateMonth6,
      //                                  this.performancLevel1VO.waterSavingRateMonth7,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3,
      //                          this.performancLevel1VO.waterCompletionMonth4,
      //                            this.performancLevel1VO.waterCompletionMonth5,
      //                               this.performancLevel1VO.waterCompletionMonth6,
      //                                 this.performancLevel1VO.waterCompletionMonth7,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 8:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
      //               this.montharr2=["9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3,
      //                         this.performancLevel1VO.waterMonth4,
      //                            this.performancLevel1VO.waterMonth5,
      //                              this.performancLevel1VO.waterMonth6,
      //                               this.performancLevel1VO.waterMonth7,
      //                                this.performancLevel1VO.waterMonth8,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3,
      //                          this.performancLevel1VO.waterSavingRateMonth4,
      //                           this.performancLevel1VO.waterSavingRateMonth5,
      //                            this.performancLevel1VO.waterSavingRateMonth6,
      //                                  this.performancLevel1VO.waterSavingRateMonth7,
      //                                      this.performancLevel1VO.waterSavingRateMonth8,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3,
      //                          this.performancLevel1VO.waterCompletionMonth4,
      //                            this.performancLevel1VO.waterCompletionMonth5,
      //                               this.performancLevel1VO.waterCompletionMonth6,
      //                                 this.performancLevel1VO.waterCompletionMonth7,
      //                                   this.performancLevel1VO.waterCompletionMonth8,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 9:
      //               this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
      //               this.montharr2=["10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3,
      //                         this.performancLevel1VO.waterMonth4,
      //                            this.performancLevel1VO.waterMonth5,
      //                              this.performancLevel1VO.waterMonth6,
      //                               this.performancLevel1VO.waterMonth7,
      //                                this.performancLevel1VO.waterMonth8,
      //                                    this.performancLevel1VO.waterMonth9,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3,
      //                          this.performancLevel1VO.waterSavingRateMonth4,
      //                           this.performancLevel1VO.waterSavingRateMonth5,
      //                            this.performancLevel1VO.waterSavingRateMonth6,
      //                                  this.performancLevel1VO.waterSavingRateMonth7,
      //                                      this.performancLevel1VO.waterSavingRateMonth8,
      //                                       this.performancLevel1VO.waterSavingRateMonth9,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3,
      //                          this.performancLevel1VO.waterCompletionMonth4,
      //                            this.performancLevel1VO.waterCompletionMonth5,
      //                               this.performancLevel1VO.waterCompletionMonth6,
      //                                 this.performancLevel1VO.waterCompletionMonth7,
      //                                   this.performancLevel1VO.waterCompletionMonth8,
      //                                      this.performancLevel1VO.waterCompletionMonth9,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 10:
      //                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
      //               this.montharr2=["11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3,
      //                         this.performancLevel1VO.waterMonth4,
      //                            this.performancLevel1VO.waterMonth5,
      //                              this.performancLevel1VO.waterMonth6,
      //                               this.performancLevel1VO.waterMonth7,
      //                                this.performancLevel1VO.waterMonth8,
      //                                    this.performancLevel1VO.waterMonth9,
      //                                     this.performancLevel1VO.waterMonth10,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3,
      //                          this.performancLevel1VO.waterSavingRateMonth4,
      //                           this.performancLevel1VO.waterSavingRateMonth5,
      //                            this.performancLevel1VO.waterSavingRateMonth6,
      //                                  this.performancLevel1VO.waterSavingRateMonth7,
      //                                      this.performancLevel1VO.waterSavingRateMonth8,
      //                                       this.performancLevel1VO.waterSavingRateMonth9,
      //                                       this.performancLevel1VO.waterSavingRateMonth10,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3,
      //                          this.performancLevel1VO.waterCompletionMonth4,
      //                            this.performancLevel1VO.waterCompletionMonth5,
      //                               this.performancLevel1VO.waterCompletionMonth6,
      //                                 this.performancLevel1VO.waterCompletionMonth7,
      //                                   this.performancLevel1VO.waterCompletionMonth8,
      //                                      this.performancLevel1VO.waterCompletionMonth9,
      //                                       this.performancLevel1VO.waterCompletionMonth10,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 11:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
      //               this.montharr2=["12月"];
      //                this.dataarr=[this.performancLevel1VO.waterMonth1,
      //                        this.performancLevel1VO.waterMonth2,
      //                        this.performancLevel1VO.waterMonth3,
      //                         this.performancLevel1VO.waterMonth4,
      //                            this.performancLevel1VO.waterMonth5,
      //                              this.performancLevel1VO.waterMonth6,
      //                               this.performancLevel1VO.waterMonth7,
      //                                this.performancLevel1VO.waterMonth8,
      //                                    this.performancLevel1VO.waterMonth9,
      //                                     this.performancLevel1VO.waterMonth10,
      //                                      this.performancLevel1VO.waterMonth11,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
      //                          this.performancLevel1VO.waterSavingRateMonth2,
      //                          this.performancLevel1VO.waterSavingRateMonth3,
      //                          this.performancLevel1VO.waterSavingRateMonth4,
      //                           this.performancLevel1VO.waterSavingRateMonth5,
      //                            this.performancLevel1VO.waterSavingRateMonth6,
      //                                  this.performancLevel1VO.waterSavingRateMonth7,
      //                                      this.performancLevel1VO.waterSavingRateMonth8,
      //                                       this.performancLevel1VO.waterSavingRateMonth9,
      //                                       this.performancLevel1VO.waterSavingRateMonth10,
      //                                       this.performancLevel1VO.waterSavingRateMonth11,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
      //                         this.performancLevel1VO.waterCompletionMonth2,
      //                         this.performancLevel1VO.waterCompletionMonth3,
      //                          this.performancLevel1VO.waterCompletionMonth4,
      //                            this.performancLevel1VO.waterCompletionMonth5,
      //                               this.performancLevel1VO.waterCompletionMonth6,
      //                                 this.performancLevel1VO.waterCompletionMonth7,
      //                                   this.performancLevel1VO.waterCompletionMonth8,
      //                                      this.performancLevel1VO.waterCompletionMonth9,
      //                                       this.performancLevel1VO.waterCompletionMonth10,
      //                                        this.performancLevel1VO.waterCompletionMonth11,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth6,
      //                       this.performancLevel1VO.waterForecastMonth7,
      //                       this.performancLevel1VO.waterForecastMonth8,
      //                       this.performancLevel1VO.waterForecastMonth9,
      //                       this.performancLevel1VO.waterForecastMonth10,
      //                       this.performancLevel1VO.waterForecastMonth11,
      //                       this.performancLevel1VO.waterForecastMonth12,
      //                       ];//预测值   
      //                       break;

      //        }
      //       // dataarr=
      //     }
      //       if(flag==3){
      //        switch(curmonth){
      //           case 0:
      //             this.montharr=["1月"];
      //              this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //              this.dataarr=[this.performancLevel1VO.gasMonth1];//目标值
      //              this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1];//实际值
      //              this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1];//评价
      //              this.dataarr3=[this.performancLevel1VO.gasForecastMonth1,
      //                       this.performancLevel1VO.gasForecastMonth3,
      //                       this.performancLevel1VO.gasForecastMonth4,
      //                       this.performancLevel1VO.gasForecastMonth5,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值
      //                       break;
                  
      //           case 1: 
      //             this. montharr=["1月","2月"];
      //               this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2];//评价
      //                this.dataarr3=[
      //                       this.performancLevel1VO.gasForecastMonth2,
      //                       this.performancLevel1VO.gasForecastMonth4,
      //                       this.performancLevel1VO.gasForecastMonth5,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值
      //                        break;
      //           case 2:
      //              this.montharr=["1月","2月","3月"];        
      //               this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"];  
      //                 this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3];//评价
      //                this.dataarr3=[
                            
      //                       this.performancLevel1VO.gasForecastMonth3,
      //                       this.performancLevel1VO.gasForecastMonth5,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值  
      //                         break;
      //           case 3:
      //              this.montharr=["1月","2月","3月","4月"];
      //               this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3,
      //                         this.performancLevel1VO.gasMonth4];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3,
      //                          this.performancLevel1VO.gasSavingRateMonth4];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3,
      //                          this.performancLevel1VO.gasCompletionMonth4];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.gasForecastMonth4,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 4:
      //                this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3,
      //                         this.performancLevel1VO.gasMonth4,
      //                            this.performancLevel1VO.gasMonth5,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3,
      //                          this.performancLevel1VO.gasSavingRateMonth4,
      //                           this.performancLevel1VO.gasSavingRateMonth5,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3,
      //                          this.performancLevel1VO.gasCompletionMonth4,
      //                            this.performancLevel1VO.gasCompletionMonth5,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.gasForecastMonth5,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 5:
      //               this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3,
      //                         this.performancLevel1VO.gasMonth4,
      //                            this.performancLevel1VO.gasMonth5,
      //                              this.performancLevel1VO.gasMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3,
      //                          this.performancLevel1VO.gasSavingRateMonth4,
      //                           this.performancLevel1VO.gasSavingRateMonth5,
      //                            this.performancLevel1VO.gasSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3,
      //                          this.performancLevel1VO.gasCompletionMonth4,
      //                            this.performancLevel1VO.gasCompletionMonth5,
      //                               this.performancLevel1VO.gasCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 6:
      //                this.montharr=["1月","2月","3月","4月","5月","6月"];
      //               this.montharr2=["7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3,
      //                         this.performancLevel1VO.gasMonth4,
      //                            this.performancLevel1VO.gasMonth5,
      //                              this.performancLevel1VO.gasMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3,
      //                          this.performancLevel1VO.gasSavingRateMonth4,
      //                           this.performancLevel1VO.gasSavingRateMonth5,
      //                            this.performancLevel1VO.gasSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3,
      //                          this.performancLevel1VO.gasCompletionMonth4,
      //                            this.performancLevel1VO.gasCompletionMonth5,
      //                               this.performancLevel1VO.gasCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 7: 
      //              this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
      //               this.montharr2=["8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3,
      //                         this.performancLevel1VO.gasMonth4,
      //                            this.performancLevel1VO.gasMonth5,
      //                              this.performancLevel1VO.gasMonth6,
      //                               this.performancLevel1VO.gasMonth7,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3,
      //                          this.performancLevel1VO.gasSavingRateMonth4,
      //                           this.performancLevel1VO.gasSavingRateMonth5,
      //                            this.performancLevel1VO.gasSavingRateMonth6,
      //                                  this.performancLevel1VO.gasSavingRateMonth7,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3,
      //                          this.performancLevel1VO.gasCompletionMonth4,
      //                            this.performancLevel1VO.gasCompletionMonth5,
      //                               this.performancLevel1VO.gasCompletionMonth6,
      //                                 this.performancLevel1VO.gasCompletionMonth7,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 8:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
      //               this.montharr2=["9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3,
      //                         this.performancLevel1VO.gasMonth4,
      //                            this.performancLevel1VO.gasMonth5,
      //                              this.performancLevel1VO.gasMonth6,
      //                               this.performancLevel1VO.gasMonth7,
      //                                this.performancLevel1VO.gasMonth8,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3,
      //                          this.performancLevel1VO.gasSavingRateMonth4,
      //                           this.performancLevel1VO.gasSavingRateMonth5,
      //                            this.performancLevel1VO.gasSavingRateMonth6,
      //                                  this.performancLevel1VO.gasSavingRateMonth7,
      //                                      this.performancLevel1VO.gasSavingRateMonth8,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3,
      //                          this.performancLevel1VO.gasCompletionMonth4,
      //                            this.performancLevel1VO.gasCompletionMonth5,
      //                               this.performancLevel1VO.gasCompletionMonth6,
      //                                 this.performancLevel1VO.gasCompletionMonth7,
      //                                   this.performancLevel1VO.gasCompletionMonth8,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 9:
      //               this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
      //               this.montharr2=["10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3,
      //                         this.performancLevel1VO.gasMonth4,
      //                            this.performancLevel1VO.gasMonth5,
      //                              this.performancLevel1VO.gasMonth6,
      //                               this.performancLevel1VO.gasMonth7,
      //                                this.performancLevel1VO.gasMonth8,
      //                                    this.performancLevel1VO.gasMonth9,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3,
      //                          this.performancLevel1VO.gasSavingRateMonth4,
      //                           this.performancLevel1VO.gasSavingRateMonth5,
      //                            this.performancLevel1VO.gasSavingRateMonth6,
      //                                  this.performancLevel1VO.gasSavingRateMonth7,
      //                                      this.performancLevel1VO.gasSavingRateMonth8,
      //                                       this.performancLevel1VO.gasSavingRateMonth9,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3,
      //                          this.performancLevel1VO.gasCompletionMonth4,
      //                            this.performancLevel1VO.gasCompletionMonth5,
      //                               this.performancLevel1VO.gasCompletionMonth6,
      //                                 this.performancLevel1VO.gasCompletionMonth7,
      //                                   this.performancLevel1VO.gasCompletionMonth8,
      //                                      this.performancLevel1VO.gasCompletionMonth9,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 10:
      //                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
      //               this.montharr2=["11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3,
      //                         this.performancLevel1VO.gasMonth4,
      //                            this.performancLevel1VO.gasMonth5,
      //                              this.performancLevel1VO.gasMonth6,
      //                               this.performancLevel1VO.gasMonth7,
      //                                this.performancLevel1VO.gasMonth8,
      //                                    this.performancLevel1VO.gasMonth9,
      //                                     this.performancLevel1VO.gasMonth10,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3,
      //                          this.performancLevel1VO.gasSavingRateMonth4,
      //                           this.performancLevel1VO.gasSavingRateMonth5,
      //                            this.performancLevel1VO.gasSavingRateMonth6,
      //                                  this.performancLevel1VO.gasSavingRateMonth7,
      //                                      this.performancLevel1VO.gasSavingRateMonth8,
      //                                       this.performancLevel1VO.gasSavingRateMonth9,
      //                                       this.performancLevel1VO.gasSavingRateMonth10,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3,
      //                          this.performancLevel1VO.gasCompletionMonth4,
      //                            this.performancLevel1VO.gasCompletionMonth5,
      //                               this.performancLevel1VO.gasCompletionMonth6,
      //                                 this.performancLevel1VO.gasCompletionMonth7,
      //                                   this.performancLevel1VO.gasCompletionMonth8,
      //                                      this.performancLevel1VO.gasCompletionMonth9,
      //                                       this.performancLevel1VO.gasCompletionMonth10,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 11:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
      //               this.montharr2=["12月"];
      //                this.dataarr=[this.performancLevel1VO.gasMonth1,
      //                        this.performancLevel1VO.gasMonth2,
      //                        this.performancLevel1VO.gasMonth3,
      //                         this.performancLevel1VO.gasMonth4,
      //                            this.performancLevel1VO.gasMonth5,
      //                              this.performancLevel1VO.gasMonth6,
      //                               this.performancLevel1VO.gasMonth7,
      //                                this.performancLevel1VO.gasMonth8,
      //                                    this.performancLevel1VO.gasMonth9,
      //                                     this.performancLevel1VO.gasMonth10,
      //                                      this.performancLevel1VO.gasMonth11,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
      //                          this.performancLevel1VO.gasSavingRateMonth2,
      //                          this.performancLevel1VO.gasSavingRateMonth3,
      //                          this.performancLevel1VO.gasSavingRateMonth4,
      //                           this.performancLevel1VO.gasSavingRateMonth5,
      //                            this.performancLevel1VO.gasSavingRateMonth6,
      //                                  this.performancLevel1VO.gasSavingRateMonth7,
      //                                      this.performancLevel1VO.gasSavingRateMonth8,
      //                                       this.performancLevel1VO.gasSavingRateMonth9,
      //                                       this.performancLevel1VO.gasSavingRateMonth10,
      //                                       this.performancLevel1VO.gasSavingRateMonth11,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
      //                         this.performancLevel1VO.gasCompletionMonth2,
      //                         this.performancLevel1VO.gasCompletionMonth3,
      //                          this.performancLevel1VO.gasCompletionMonth4,
      //                            this.performancLevel1VO.gasCompletionMonth5,
      //                               this.performancLevel1VO.gasCompletionMonth6,
      //                                 this.performancLevel1VO.gasCompletionMonth7,
      //                                   this.performancLevel1VO.gasCompletionMonth8,
      //                                      this.performancLevel1VO.gasCompletionMonth9,
      //                                       this.performancLevel1VO.gasCompletionMonth10,
      //                                        this.performancLevel1VO.gasCompletionMonth11,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth6,
      //                       this.performancLevel1VO.gasForecastMonth7,
      //                       this.performancLevel1VO.gasForecastMonth8,
      //                       this.performancLevel1VO.gasForecastMonth9,
      //                       this.performancLevel1VO.gasForecastMonth10,
      //                       this.performancLevel1VO.gasForecastMonth11,
      //                       this.performancLevel1VO.gasForecastMonth12,
      //                       ];//预测值   
      //                       break;

      //        }
      //       // dataarr=
      //     }
      //       if(flag==4){
      //        switch(curmonth){
      //           case 0:
      //             this.montharr=["1月"];
      //              this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //              this.dataarr=[this.performancLevel1VO.hotMonth1];//目标值
      //              this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1];//实际值
      //              this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1];//评价
      //              this.dataarr3=[this.performancLevel1VO.hotForecastMonth1,
      //                       this.performancLevel1VO.hotForecastMonth3,
      //                       this.performancLevel1VO.hotForecastMonth4,
      //                       this.performancLevel1VO.hotForecastMonth5,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值
      //                       break;
                  
      //           case 1: 
      //             this. montharr=["1月","2月"];
      //               this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2];//评价
      //                this.dataarr3=[
      //                       this.performancLevel1VO.hotForecastMonth2,
      //                       this.performancLevel1VO.hotForecastMonth4,
      //                       this.performancLevel1VO.hotForecastMonth5,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值
      //                        break;
      //           case 2:
      //              this.montharr=["1月","2月","3月"];        
      //               this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"];  
      //                 this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3];//评价
      //                this.dataarr3=[
                            
      //                       this.performancLevel1VO.hotForecastMonth3,
      //                       this.performancLevel1VO.hotForecastMonth5,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值  
      //                         break;
      //           case 3:
      //              this.montharr=["1月","2月","3月","4月"];
      //               this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3,
      //                         this.performancLevel1VO.hotMonth4];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3,
      //                          this.performancLevel1VO.hotSavingRateMonth4];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3,
      //                          this.performancLevel1VO.hotCompletionMonth4];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.hotForecastMonth4,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 4:
      //                this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3,
      //                         this.performancLevel1VO.hotMonth4,
      //                            this.performancLevel1VO.hotMonth5,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3,
      //                          this.performancLevel1VO.hotSavingRateMonth4,
      //                           this.performancLevel1VO.hotSavingRateMonth5,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3,
      //                          this.performancLevel1VO.hotCompletionMonth4,
      //                            this.performancLevel1VO.hotCompletionMonth5,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.hotForecastMonth5,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 5:
      //               this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3,
      //                         this.performancLevel1VO.hotMonth4,
      //                            this.performancLevel1VO.hotMonth5,
      //                              this.performancLevel1VO.hotMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3,
      //                          this.performancLevel1VO.hotSavingRateMonth4,
      //                           this.performancLevel1VO.hotSavingRateMonth5,
      //                            this.performancLevel1VO.hotSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3,
      //                          this.performancLevel1VO.hotCompletionMonth4,
      //                            this.performancLevel1VO.hotCompletionMonth5,
      //                               this.performancLevel1VO.hotCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 6:
      //                this.montharr=["1月","2月","3月","4月","5月","6月"];
      //               this.montharr2=["7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3,
      //                         this.performancLevel1VO.hotMonth4,
      //                            this.performancLevel1VO.hotMonth5,
      //                              this.performancLevel1VO.hotMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3,
      //                          this.performancLevel1VO.hotSavingRateMonth4,
      //                           this.performancLevel1VO.hotSavingRateMonth5,
      //                            this.performancLevel1VO.hotSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3,
      //                          this.performancLevel1VO.hotCompletionMonth4,
      //                            this.performancLevel1VO.hotCompletionMonth5,
      //                               this.performancLevel1VO.hotCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 7: 
      //              this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
      //               this.montharr2=["8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3,
      //                         this.performancLevel1VO.hotMonth4,
      //                            this.performancLevel1VO.hotMonth5,
      //                              this.performancLevel1VO.hotMonth6,
      //                               this.performancLevel1VO.hotMonth7,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3,
      //                          this.performancLevel1VO.hotSavingRateMonth4,
      //                           this.performancLevel1VO.hotSavingRateMonth5,
      //                            this.performancLevel1VO.hotSavingRateMonth6,
      //                                  this.performancLevel1VO.hotSavingRateMonth7,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3,
      //                          this.performancLevel1VO.hotCompletionMonth4,
      //                            this.performancLevel1VO.hotCompletionMonth5,
      //                               this.performancLevel1VO.hotCompletionMonth6,
      //                                 this.performancLevel1VO.hotCompletionMonth7,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 8:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
      //               this.montharr2=["9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3,
      //                         this.performancLevel1VO.hotMonth4,
      //                            this.performancLevel1VO.hotMonth5,
      //                              this.performancLevel1VO.hotMonth6,
      //                               this.performancLevel1VO.hotMonth7,
      //                                this.performancLevel1VO.hotMonth8,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3,
      //                          this.performancLevel1VO.hotSavingRateMonth4,
      //                           this.performancLevel1VO.hotSavingRateMonth5,
      //                            this.performancLevel1VO.hotSavingRateMonth6,
      //                                  this.performancLevel1VO.hotSavingRateMonth7,
      //                                      this.performancLevel1VO.hotSavingRateMonth8,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3,
      //                          this.performancLevel1VO.hotCompletionMonth4,
      //                            this.performancLevel1VO.hotCompletionMonth5,
      //                               this.performancLevel1VO.hotCompletionMonth6,
      //                                 this.performancLevel1VO.hotCompletionMonth7,
      //                                   this.performancLevel1VO.hotCompletionMonth8,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 9:
      //               this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
      //               this.montharr2=["10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3,
      //                         this.performancLevel1VO.hotMonth4,
      //                            this.performancLevel1VO.hotMonth5,
      //                              this.performancLevel1VO.hotMonth6,
      //                               this.performancLevel1VO.hotMonth7,
      //                                this.performancLevel1VO.hotMonth8,
      //                                    this.performancLevel1VO.hotMonth9,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3,
      //                          this.performancLevel1VO.hotSavingRateMonth4,
      //                           this.performancLevel1VO.hotSavingRateMonth5,
      //                            this.performancLevel1VO.hotSavingRateMonth6,
      //                                  this.performancLevel1VO.hotSavingRateMonth7,
      //                                      this.performancLevel1VO.hotSavingRateMonth8,
      //                                       this.performancLevel1VO.hotSavingRateMonth9,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3,
      //                          this.performancLevel1VO.hotCompletionMonth4,
      //                            this.performancLevel1VO.hotCompletionMonth5,
      //                               this.performancLevel1VO.hotCompletionMonth6,
      //                                 this.performancLevel1VO.hotCompletionMonth7,
      //                                   this.performancLevel1VO.hotCompletionMonth8,
      //                                      this.performancLevel1VO.hotCompletionMonth9,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 10:
      //                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
      //               this.montharr2=["11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3,
      //                         this.performancLevel1VO.hotMonth4,
      //                            this.performancLevel1VO.hotMonth5,
      //                              this.performancLevel1VO.hotMonth6,
      //                               this.performancLevel1VO.hotMonth7,
      //                                this.performancLevel1VO.hotMonth8,
      //                                    this.performancLevel1VO.hotMonth9,
      //                                     this.performancLevel1VO.hotMonth10,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3,
      //                          this.performancLevel1VO.hotSavingRateMonth4,
      //                           this.performancLevel1VO.hotSavingRateMonth5,
      //                            this.performancLevel1VO.hotSavingRateMonth6,
      //                                  this.performancLevel1VO.hotSavingRateMonth7,
      //                                      this.performancLevel1VO.hotSavingRateMonth8,
      //                                       this.performancLevel1VO.hotSavingRateMonth9,
      //                                       this.performancLevel1VO.hotSavingRateMonth10,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3,
      //                          this.performancLevel1VO.hotCompletionMonth4,
      //                            this.performancLevel1VO.hotCompletionMonth5,
      //                               this.performancLevel1VO.hotCompletionMonth6,
      //                                 this.performancLevel1VO.hotCompletionMonth7,
      //                                   this.performancLevel1VO.hotCompletionMonth8,
      //                                      this.performancLevel1VO.hotCompletionMonth9,
      //                                       this.performancLevel1VO.hotCompletionMonth10,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 11:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
      //               this.montharr2=["12月"];
      //                this.dataarr=[this.performancLevel1VO.hotMonth1,
      //                        this.performancLevel1VO.hotMonth2,
      //                        this.performancLevel1VO.hotMonth3,
      //                         this.performancLevel1VO.hotMonth4,
      //                            this.performancLevel1VO.hotMonth5,
      //                              this.performancLevel1VO.hotMonth6,
      //                               this.performancLevel1VO.hotMonth7,
      //                                this.performancLevel1VO.hotMonth8,
      //                                    this.performancLevel1VO.hotMonth9,
      //                                     this.performancLevel1VO.hotMonth10,
      //                                      this.performancLevel1VO.hotMonth11,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
      //                          this.performancLevel1VO.hotSavingRateMonth2,
      //                          this.performancLevel1VO.hotSavingRateMonth3,
      //                          this.performancLevel1VO.hotSavingRateMonth4,
      //                           this.performancLevel1VO.hotSavingRateMonth5,
      //                            this.performancLevel1VO.hotSavingRateMonth6,
      //                                  this.performancLevel1VO.hotSavingRateMonth7,
      //                                      this.performancLevel1VO.hotSavingRateMonth8,
      //                                       this.performancLevel1VO.hotSavingRateMonth9,
      //                                       this.performancLevel1VO.hotSavingRateMonth10,
      //                                       this.performancLevel1VO.hotSavingRateMonth11,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
      //                         this.performancLevel1VO.hotCompletionMonth2,
      //                         this.performancLevel1VO.hotCompletionMonth3,
      //                          this.performancLevel1VO.hotCompletionMonth4,
      //                            this.performancLevel1VO.hotCompletionMonth5,
      //                               this.performancLevel1VO.hotCompletionMonth6,
      //                                 this.performancLevel1VO.hotCompletionMonth7,
      //                                   this.performancLevel1VO.hotCompletionMonth8,
      //                                      this.performancLevel1VO.hotCompletionMonth9,
      //                                       this.performancLevel1VO.hotCompletionMonth10,
      //                                        this.performancLevel1VO.hotCompletionMonth11,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth6,
      //                       this.performancLevel1VO.hotForecastMonth7,
      //                       this.performancLevel1VO.hotForecastMonth8,
      //                       this.performancLevel1VO.hotForecastMonth9,
      //                       this.performancLevel1VO.hotForecastMonth10,
      //                       this.performancLevel1VO.hotForecastMonth11,
      //                       this.performancLevel1VO.hotForecastMonth12,
      //                       ];//预测值   
      //                       break;

      //        }
      //       // dataarr=
      //     }
      //       if(flag==5){
      //        switch(curmonth){
      //           case 0:
      //             this.montharr=["1月"];
      //              this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //              this.dataarr=[this.performancLevel1VO.othersMonth1];//目标值
      //              this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1];//实际值
      //              this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1];//评价
      //              this.dataarr3=[this.performancLevel1VO.othersForecastMonth1,
      //                       this.performancLevel1VO.othersForecastMonth3,
      //                       this.performancLevel1VO.othersForecastMonth4,
      //                       this.performancLevel1VO.othersForecastMonth5,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值
      //                       break;
                  
      //           case 1: 
      //             this. montharr=["1月","2月"];
      //               this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2];//评价
      //                this.dataarr3=[
      //                       this.performancLevel1VO.othersForecastMonth2,
      //                       this.performancLevel1VO.othersForecastMonth4,
      //                       this.performancLevel1VO.othersForecastMonth5,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值
      //                        break;
      //           case 2:
      //              this.montharr=["1月","2月","3月"];        
      //               this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"];  
      //                 this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3];//评价
      //                this.dataarr3=[
                            
      //                       this.performancLevel1VO.othersForecastMonth3,
      //                       this.performancLevel1VO.othersForecastMonth5,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值  
      //                         break;
      //           case 3:
      //              this.montharr=["1月","2月","3月","4月"];
      //               this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3,
      //                         this.performancLevel1VO.othersMonth4];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3,
      //                          this.performancLevel1VO.othersSavingRateMonth4];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3,
      //                          this.performancLevel1VO.othersCompletionMonth4];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.othersForecastMonth4,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 4:
      //                this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3,
      //                         this.performancLevel1VO.othersMonth4,
      //                            this.performancLevel1VO.othersMonth5,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3,
      //                          this.performancLevel1VO.othersSavingRateMonth4,
      //                           this.performancLevel1VO.othersSavingRateMonth5,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3,
      //                          this.performancLevel1VO.othersCompletionMonth4,
      //                            this.performancLevel1VO.othersCompletionMonth5,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.othersForecastMonth5,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 5:
      //               this.montharr=["1月","2月","3月","4月","5月"];
      //               this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3,
      //                         this.performancLevel1VO.othersMonth4,
      //                            this.performancLevel1VO.othersMonth5,
      //                              this.performancLevel1VO.othersMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3,
      //                          this.performancLevel1VO.othersSavingRateMonth4,
      //                           this.performancLevel1VO.othersSavingRateMonth5,
      //                            this.performancLevel1VO.othersSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3,
      //                          this.performancLevel1VO.othersCompletionMonth4,
      //                            this.performancLevel1VO.othersCompletionMonth5,
      //                               this.performancLevel1VO.othersCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 6:
      //                this.montharr=["1月","2月","3月","4月","5月","6月"];
      //               this.montharr2=["7月","8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3,
      //                         this.performancLevel1VO.othersMonth4,
      //                            this.performancLevel1VO.othersMonth5,
      //                              this.performancLevel1VO.othersMonth6,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3,
      //                          this.performancLevel1VO.othersSavingRateMonth4,
      //                           this.performancLevel1VO.othersSavingRateMonth5,
      //                            this.performancLevel1VO.othersSavingRateMonth6,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3,
      //                          this.performancLevel1VO.othersCompletionMonth4,
      //                            this.performancLevel1VO.othersCompletionMonth5,
      //                               this.performancLevel1VO.othersCompletionMonth6,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 7: 
      //              this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
      //               this.montharr2=["8月","9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3,
      //                         this.performancLevel1VO.othersMonth4,
      //                            this.performancLevel1VO.othersMonth5,
      //                              this.performancLevel1VO.othersMonth6,
      //                               this.performancLevel1VO.othersMonth7,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3,
      //                          this.performancLevel1VO.othersSavingRateMonth4,
      //                           this.performancLevel1VO.othersSavingRateMonth5,
      //                            this.performancLevel1VO.othersSavingRateMonth6,
      //                                  this.performancLevel1VO.othersSavingRateMonth7,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3,
      //                          this.performancLevel1VO.othersCompletionMonth4,
      //                            this.performancLevel1VO.othersCompletionMonth5,
      //                               this.performancLevel1VO.othersCompletionMonth6,
      //                                 this.performancLevel1VO.othersCompletionMonth7,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 8:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
      //               this.montharr2=["9月","10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3,
      //                         this.performancLevel1VO.othersMonth4,
      //                            this.performancLevel1VO.othersMonth5,
      //                              this.performancLevel1VO.othersMonth6,
      //                               this.performancLevel1VO.othersMonth7,
      //                                this.performancLevel1VO.othersMonth8,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3,
      //                          this.performancLevel1VO.othersSavingRateMonth4,
      //                           this.performancLevel1VO.othersSavingRateMonth5,
      //                            this.performancLevel1VO.othersSavingRateMonth6,
      //                                  this.performancLevel1VO.othersSavingRateMonth7,
      //                                      this.performancLevel1VO.othersSavingRateMonth8,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3,
      //                          this.performancLevel1VO.othersCompletionMonth4,
      //                            this.performancLevel1VO.othersCompletionMonth5,
      //                               this.performancLevel1VO.othersCompletionMonth6,
      //                                 this.performancLevel1VO.othersCompletionMonth7,
      //                                   this.performancLevel1VO.othersCompletionMonth8,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 9:
      //               this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
      //               this.montharr2=["10月","11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3,
      //                         this.performancLevel1VO.othersMonth4,
      //                            this.performancLevel1VO.othersMonth5,
      //                              this.performancLevel1VO.othersMonth6,
      //                               this.performancLevel1VO.othersMonth7,
      //                                this.performancLevel1VO.othersMonth8,
      //                                    this.performancLevel1VO.othersMonth9,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3,
      //                          this.performancLevel1VO.othersSavingRateMonth4,
      //                           this.performancLevel1VO.othersSavingRateMonth5,
      //                            this.performancLevel1VO.othersSavingRateMonth6,
      //                                  this.performancLevel1VO.othersSavingRateMonth7,
      //                                      this.performancLevel1VO.othersSavingRateMonth8,
      //                                       this.performancLevel1VO.othersSavingRateMonth9,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3,
      //                          this.performancLevel1VO.othersCompletionMonth4,
      //                            this.performancLevel1VO.othersCompletionMonth5,
      //                               this.performancLevel1VO.othersCompletionMonth6,
      //                                 this.performancLevel1VO.othersCompletionMonth7,
      //                                   this.performancLevel1VO.othersCompletionMonth8,
      //                                      this.performancLevel1VO.othersCompletionMonth9,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 10:
      //                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
      //               this.montharr2=["11月","12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3,
      //                         this.performancLevel1VO.othersMonth4,
      //                            this.performancLevel1VO.othersMonth5,
      //                              this.performancLevel1VO.othersMonth6,
      //                               this.performancLevel1VO.othersMonth7,
      //                                this.performancLevel1VO.othersMonth8,
      //                                    this.performancLevel1VO.othersMonth9,
      //                                     this.performancLevel1VO.othersMonth10,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3,
      //                          this.performancLevel1VO.othersSavingRateMonth4,
      //                           this.performancLevel1VO.othersSavingRateMonth5,
      //                            this.performancLevel1VO.othersSavingRateMonth6,
      //                                  this.performancLevel1VO.othersSavingRateMonth7,
      //                                      this.performancLevel1VO.othersSavingRateMonth8,
      //                                       this.performancLevel1VO.othersSavingRateMonth9,
      //                                       this.performancLevel1VO.othersSavingRateMonth10,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3,
      //                          this.performancLevel1VO.othersCompletionMonth4,
      //                            this.performancLevel1VO.othersCompletionMonth5,
      //                               this.performancLevel1VO.othersCompletionMonth6,
      //                                 this.performancLevel1VO.othersCompletionMonth7,
      //                                   this.performancLevel1VO.othersCompletionMonth8,
      //                                      this.performancLevel1VO.othersCompletionMonth9,
      //                                       this.performancLevel1VO.othersCompletionMonth10,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值   
      //                       break;
      //           case 11:
      //                this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
      //               this.montharr2=["12月"];
      //                this.dataarr=[this.performancLevel1VO.othersMonth1,
      //                        this.performancLevel1VO.othersMonth2,
      //                        this.performancLevel1VO.othersMonth3,
      //                         this.performancLevel1VO.othersMonth4,
      //                            this.performancLevel1VO.othersMonth5,
      //                              this.performancLevel1VO.othersMonth6,
      //                               this.performancLevel1VO.othersMonth7,
      //                                this.performancLevel1VO.othersMonth8,
      //                                    this.performancLevel1VO.othersMonth9,
      //                                     this.performancLevel1VO.othersMonth10,
      //                                      this.performancLevel1VO.othersMonth11,
      //                         ];//目标值
      //                this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
      //                          this.performancLevel1VO.othersSavingRateMonth2,
      //                          this.performancLevel1VO.othersSavingRateMonth3,
      //                          this.performancLevel1VO.othersSavingRateMonth4,
      //                           this.performancLevel1VO.othersSavingRateMonth5,
      //                            this.performancLevel1VO.othersSavingRateMonth6,
      //                                  this.performancLevel1VO.othersSavingRateMonth7,
      //                                      this.performancLevel1VO.othersSavingRateMonth8,
      //                                       this.performancLevel1VO.othersSavingRateMonth9,
      //                                       this.performancLevel1VO.othersSavingRateMonth10,
      //                                       this.performancLevel1VO.othersSavingRateMonth11,
      //                          ];//实际值
      //                this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
      //                         this.performancLevel1VO.othersCompletionMonth2,
      //                         this.performancLevel1VO.othersCompletionMonth3,
      //                          this.performancLevel1VO.othersCompletionMonth4,
      //                            this.performancLevel1VO.othersCompletionMonth5,
      //                               this.performancLevel1VO.othersCompletionMonth6,
      //                                 this.performancLevel1VO.othersCompletionMonth7,
      //                                   this.performancLevel1VO.othersCompletionMonth8,
      //                                      this.performancLevel1VO.othersCompletionMonth9,
      //                                       this.performancLevel1VO.othersCompletionMonth10,
      //                                        this.performancLevel1VO.othersCompletionMonth11,
      //                          ];//评价
      //                this.dataarr3=[
                            
                         
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth6,
      //                       this.performancLevel1VO.othersForecastMonth7,
      //                       this.performancLevel1VO.othersForecastMonth8,
      //                       this.performancLevel1VO.othersForecastMonth9,
      //                       this.performancLevel1VO.othersForecastMonth10,
      //                       this.performancLevel1VO.othersForecastMonth11,
      //                       this.performancLevel1VO.othersForecastMonth12,
      //                       ];//预测值   
      //                       break;

      //        }
      //       // dataarr=
      //     }
        
      
      //       return {
      //         title: {
      //           text: "",
      //           textStyle: {
      //             fontSize: 16,
      //             color: "#000",
      //             fontWeight: "bolder",
      //           },
      //         },
      //         tooltip: {
      //           trigger: "axis",
      //          // axisPointer: { type: "cross" },
      //           //trigger: 'item',
      //       formatter: function (params) {
      //          //console.log(params);
      //               const item = params[0];
      //             var color = params.color;//图例颜色
      //             //var value = item.value;//y轴值
                 
      //             var month=item.data.month;
      //             var value = item.data.value;
      //             var change=item.data.change;
      //             var changerate=item.data.changerate;
      //             if (value==null)
      //                 value="";
      //             if (change==null)
      //                 change="";
      //             if (changerate==null)
      //                 changerate="";    
      //             var htmlStr ='<div align="left">';
                 
      //            htmlStr += month + '月<br/>';//x轴的名称
      //             //为了保证和原来的效果一样，这里自己实现了一个点的效果
      //             htmlStr += '<span style="margin-right:5px;display:inline-block;width:8px;height:10px;border-radius:5px;background-color:'+color+';"></span>';
      //             htmlStr +=  '用电量(Kwh):'+value+'<br/>';
      //             htmlStr += '<span style="margin-right:5px;display:inline-block;width:8px;height:10px;border-radius:5px;background-color:'+color+';"></span>';

      //             htmlStr +=  '同比变化量(Kwh):'+change+'<br/>';
      //             htmlStr += '<span style="margin-right:5px;display:inline-block;width:8px;height:10px;border-radius:5px;background-color:'+color+';"></span>';

      //             htmlStr +=  '同比变化率:'+changerate+'<br/>';
      //             // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
      //             //htmlStr += '<span style="color:'+color+'">';
                  
      //             //添加一个汉字，这里你可以格式你的数字或者自定义文本内容
      //             //htmlStr += params.seriesName + '：'+params.value + '笔';
      
      //             // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
      //             //htmlStr += '</span>';
                  
      //             htmlStr += '</div>';
                  
      //             return htmlStr; 
      //      }


      //         },
      //         legend: [
               
      //         {
      //            top:'25%',//距上边距

      //           left:'25%',//距离左边距

      //            right:'25%',//距离右边距

      //             bottom:'25%',//距离下边距
                
      //               // x: "right",
      //               y: "top",
      //               data: [
      //                 "用电量(Kws)"
      //               ]
      //           }
      //         ],
      //         grid: {
      //           left: "3%",
      //           right: "4%",
      //           bottom: "3%",
      //           containLabel: true,
      //         },
      //         xAxis: [
      //           {
      //             type: "category",
      //             data: [
      //               "1",
      //               "2",
      //               "3",
              
      //             ],
      //           },
      //         ],
      //         yAxis: [
      //           {
      //             type: "value",
      //             name: "",
      //             axisLine: {show:true},
      //             axisTick: {show:true},
      //             splitLine:{show:true},
      //             axisLabel: {
      //               formatter: "{value} ",
      //             },
      //           },
      //         ],
      //         series: [
      //           {
      //             name: "用电量",
      //             type: "line",
      //             symbolSize: 6,
      //              smooth:false,
      //             itemStyle : {
      //                normal : {
      //                   color:'#F1C232',
      //                   label : {show: true},
      //                lineStyle:{
      //                  color:'#F6B26B',
      //                  width:4
      //               }
      //              }
      //             },
                 
      //             data:dataarr,
      //           },
      //         ],
      //       };
      //    },
     monthlyProportionRate(flag) {
 if(flag==null || flag=="undefined")
             flag=0;
     
          
           var date = new Date();
           var curmonth=date.getMonth(); 
           // alert(curmonth);
           if(flag==0){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          // {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                      //  "2月": this.performancLevel1VO.totalForecastMonth2,
                      //   "3月": this.performancLevel1VO.totalForecastMonth3,
                      //   "4月": this.performancLevel1VO.totalForecastMonth4,
                      //   "5月": this.performancLevel1VO.totalForecastMonth5,
                      //    "6月": this.performancLevel1VO.totalForecastMonth6,
                      //     "7月": this.performancLevel1VO.totalForecastMonth7,
                      //     "8月": this.performancLevel1VO.totalForecastMonth8,
                      //     "9月": this.performancLevel1VO.totalForecastMonth9,
                      //     "10月": this.performancLevel1VO.totalForecastMonth10,
                      //     "11月": this.performancLevel1VO.totalForecastMonth11,
                      //     "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.totalCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.totalMonth1];//目标值
                  this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1];//实际值
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        // "3月": this.performancLevel1VO.totalForecastMonth3,
                        // "4月": this.performancLevel1VO.totalForecastMonth4,
                        // "5月": this.performancLevel1VO.totalForecastMonth5,
                        //  "6月": this.performancLevel1VO.totalForecastMonth6,
                        //   "7月": this.performancLevel1VO.totalForecastMonth7,
                        //   "8月": this.performancLevel1VO.totalForecastMonth8,
                        //   "9月": this.performancLevel1VO.totalForecastMonth9,
                        //   "10月": this.performancLevel1VO.totalForecastMonth10,
                        //   "11月": this.performancLevel1VO.totalForecastMonth11,
                        //   "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2];//实际值
                    this.dataarr4=[this.performancLevel1VO.totalCompletionMonth1,
                              this.performancLevel1VO.totalCompletionMonth2];//评价
                     this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.totalCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  {
                    date: '2月',
                    name: this.performancLevel1VO.totalCompletionMonth2,
                   // image: require(besturl)
                    }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        // "4月": this.performancLevel1VO.totalForecastMonth4,
                        // "5月": this.performancLevel1VO.totalForecastMonth5,
                        //  "6月": this.performancLevel1VO.totalForecastMonth6,
                        //   "7月": this.performancLevel1VO.totalForecastMonth7,
                        //   "8月": this.performancLevel1VO.totalForecastMonth8,
                        //   "9月": this.performancLevel1VO.totalForecastMonth9,
                        //   "10月": this.performancLevel1VO.totalForecastMonth10,
                        //   "11月": this.performancLevel1VO.totalForecastMonth11,
                        //   "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                     this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3];//实际值
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        "4月": this.performancLevel1VO.totalForecastMonth4,
                        // "5月": this.performancLevel1VO.totalForecastMonth5,
                        //  "6月": this.performancLevel1VO.totalForecastMonth6,
                        //   "7月": this.performancLevel1VO.totalForecastMonth7,
                        //   "8月": this.performancLevel1VO.totalForecastMonth8,
                        //   "9月": this.performancLevel1VO.totalForecastMonth9,
                        //   "10月": this.performancLevel1VO.totalForecastMonth10,
                        //   "11月": this.performancLevel1VO.totalForecastMonth11,
                        //   "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3,
                              this.performancLevel1VO.totalMonth4];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3,
                               this.performancLevel1VO.totalSavingRateMonth4];//实际值
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.totalCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        "4月": this.performancLevel1VO.totalForecastMonth4,
                        "5月": this.performancLevel1VO.totalForecastMonth5,
                        //  "6月": this.performancLevel1VO.totalForecastMonth6,
                        //   "7月": this.performancLevel1VO.totalForecastMonth7,
                        //   "8月": this.performancLevel1VO.totalForecastMonth8,
                        //   "9月": this.performancLevel1VO.totalForecastMonth9,
                        //   "10月": this.performancLevel1VO.totalForecastMonth10,
                        //   "11月": this.performancLevel1VO.totalForecastMonth11,
                        //   "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3,
                              this.performancLevel1VO.totalMonth4,
                               this.performancLevel1VO.totalMonth5];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3,
                               this.performancLevel1VO.totalSavingRateMonth4,
                               this.performancLevel1VO.totalSavingRateMonth5];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.totalCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.totalCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 5:
                   this.montharr=["1月","2月","3月","4月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        "4月": this.performancLevel1VO.totalForecastMonth4,
                        "5月": this.performancLevel1VO.totalForecastMonth5,
                         "6月": this.performancLevel1VO.totalForecastMonth6,
                          // "7月": this.performancLevel1VO.totalForecastMonth7,
                          // "8月": this.performancLevel1VO.totalForecastMonth8,
                          // "9月": this.performancLevel1VO.totalForecastMonth9,
                          // "10月": this.performancLevel1VO.totalForecastMonth10,
                          // "11月": this.performancLevel1VO.totalForecastMonth11,
                          // "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3,
                              this.performancLevel1VO.totalMonth4,
                               this.performancLevel1VO.totalMonth5,
                               this.performancLevel1VO.totalMonth6];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3,
                               this.performancLevel1VO.totalSavingRateMonth4,
                               this.performancLevel1VO.totalSavingRateMonth5,
                               this.performancLevel1VO.totalSavingRateMonth6];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.totalCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.totalCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.totalCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 6:
                    this.montharr=["1月","2月","3月","4月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        "4月": this.performancLevel1VO.totalForecastMonth4,
                        "5月": this.performancLevel1VO.totalForecastMonth5,
                         "6月": this.performancLevel1VO.totalForecastMonth6,
                          "7月": this.performancLevel1VO.totalForecastMonth7,
                          // "8月": this.performancLevel1VO.totalForecastMonth8,
                          // "9月": this.performancLevel1VO.totalForecastMonth9,
                          // "10月": this.performancLevel1VO.totalForecastMonth10,
                          // "11月": this.performancLevel1VO.totalForecastMonth11,
                          // "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3,
                              this.performancLevel1VO.totalMonth4,
                               this.performancLevel1VO.totalMonth5,
                               this.performancLevel1VO.totalMonth6,
                               this.performancLevel1VO.totalMonth7];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3,
                               this.performancLevel1VO.totalSavingRateMonth4,
                               this.performancLevel1VO.totalSavingRateMonth5,
                               this.performancLevel1VO.totalSavingRateMonth6,
                                this.performancLevel1VO.totalSavingRateMonth7];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.totalCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.totalCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.totalCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.totalCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 7: 
                  this.montharr=["1月","2月","3月","4月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        "4月": this.performancLevel1VO.totalForecastMonth4,
                        "5月": this.performancLevel1VO.totalForecastMonth5,
                         "6月": this.performancLevel1VO.totalForecastMonth6,
                          "7月": this.performancLevel1VO.totalForecastMonth7,
                          "8月": this.performancLevel1VO.totalForecastMonth8,
                          // "9月": this.performancLevel1VO.totalForecastMonth9,
                          // "10月": this.performancLevel1VO.totalForecastMonth10,
                          // "11月": this.performancLevel1VO.totalForecastMonth11,
                          // "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3,
                              this.performancLevel1VO.totalMonth4,
                               this.performancLevel1VO.totalMonth5,
                               this.performancLevel1VO.totalMonth6,
                               this.performancLevel1VO.totalMonth7,
                                this.performancLevel1VO.totalMonth8];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3,
                               this.performancLevel1VO.totalSavingRateMonth4,
                               this.performancLevel1VO.totalSavingRateMonth5,
                               this.performancLevel1VO.totalSavingRateMonth6,
                                this.performancLevel1VO.totalSavingRateMonth7,
                                  this.performancLevel1VO.totalSavingRateMonth8];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.totalCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.totalCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.totalCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.totalCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.totalCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 8:
                    this.montharr=["1月","2月","3月","4月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        "4月": this.performancLevel1VO.totalForecastMonth4,
                        "5月": this.performancLevel1VO.totalForecastMonth5,
                         "6月": this.performancLevel1VO.totalForecastMonth6,
                          "7月": this.performancLevel1VO.totalForecastMonth7,
                          "8月": this.performancLevel1VO.totalForecastMonth8,
                          "9月": this.performancLevel1VO.totalForecastMonth9,
                          // "10月": this.performancLevel1VO.totalForecastMonth10,
                          // "11月": this.performancLevel1VO.totalForecastMonth11,
                          // "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3,
                              this.performancLevel1VO.totalMonth4,
                               this.performancLevel1VO.totalMonth5,
                               this.performancLevel1VO.totalMonth6,
                               this.performancLevel1VO.totalMonth7,
                                this.performancLevel1VO.totalMonth8,
                                 this.performancLevel1VO.totalMonth9];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3,
                               this.performancLevel1VO.totalSavingRateMonth4,
                               this.performancLevel1VO.totalSavingRateMonth5,
                               this.performancLevel1VO.totalSavingRateMonth6,
                                this.performancLevel1VO.totalSavingRateMonth7,
                                  this.performancLevel1VO.totalSavingRateMonth8,
                                  this.performancLevel1VO.totalSavingRateMonth9];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.totalCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.totalCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.totalCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.totalCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.totalCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.totalCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 9:
                    this.montharr=["1月","2月","3月","4月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        "4月": this.performancLevel1VO.totalForecastMonth4,
                        "5月": this.performancLevel1VO.totalForecastMonth5,
                         "6月": this.performancLevel1VO.totalForecastMonth6,
                          "7月": this.performancLevel1VO.totalForecastMonth7,
                          "8月": this.performancLevel1VO.totalForecastMonth8,
                          "9月": this.performancLevel1VO.totalForecastMonth9,
                          "10月": this.performancLevel1VO.totalForecastMonth10,
                          // "11月": this.performancLevel1VO.totalForecastMonth11,
                          // "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3,
                              this.performancLevel1VO.totalMonth4,
                               this.performancLevel1VO.totalMonth5,
                               this.performancLevel1VO.totalMonth6,
                               this.performancLevel1VO.totalMonth7,
                                this.performancLevel1VO.totalMonth8,
                                 this.performancLevel1VO.totalMonth9,
                                 this.performancLevel1VO.totalMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3,
                               this.performancLevel1VO.totalSavingRateMonth4,
                               this.performancLevel1VO.totalSavingRateMonth5,
                               this.performancLevel1VO.totalSavingRateMonth6,
                                this.performancLevel1VO.totalSavingRateMonth7,
                                  this.performancLevel1VO.totalSavingRateMonth8,
                                  this.performancLevel1VO.totalSavingRateMonth9,
                                   this.performancLevel1VO.totalSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.totalCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.totalCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.totalCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.totalCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.totalCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.totalCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.totalCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 10:
                   this.montharr=["1月","2月","3月","4月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        "4月": this.performancLevel1VO.totalForecastMonth4,
                        "5月": this.performancLevel1VO.totalForecastMonth5,
                         "6月": this.performancLevel1VO.totalForecastMonth6,
                          "7月": this.performancLevel1VO.totalForecastMonth7,
                          "8月": this.performancLevel1VO.totalForecastMonth8,
                          "9月": this.performancLevel1VO.totalForecastMonth9,
                          "10月": this.performancLevel1VO.totalForecastMonth10,
                          "11月": this.performancLevel1VO.totalForecastMonth11,
                          //"12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3,
                              this.performancLevel1VO.totalMonth4,
                               this.performancLevel1VO.totalMonth5,
                               this.performancLevel1VO.totalMonth6,
                               this.performancLevel1VO.totalMonth7,
                                this.performancLevel1VO.totalMonth8,
                                 this.performancLevel1VO.totalMonth9,
                                 this.performancLevel1VO.totalMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3,
                               this.performancLevel1VO.totalSavingRateMonth4,
                               this.performancLevel1VO.totalSavingRateMonth5,
                               this.performancLevel1VO.totalSavingRateMonth6,
                                this.performancLevel1VO.totalSavingRateMonth7,
                                  this.performancLevel1VO.totalSavingRateMonth8,
                                  this.performancLevel1VO.totalSavingRateMonth9,
                                   this.performancLevel1VO.totalSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.totalCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.totalCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.totalCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.totalCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.totalCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.totalCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.totalCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 11:
  this.montharr=["1月","2月","3月","4月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.totalForecastMonth1,
                       "2月": this.performancLevel1VO.totalForecastMonth2,
                        "3月": this.performancLevel1VO.totalForecastMonth3,
                        "4月": this.performancLevel1VO.totalForecastMonth4,
                        "5月": this.performancLevel1VO.totalForecastMonth5,
                         "6月": this.performancLevel1VO.totalForecastMonth6,
                          "7月": this.performancLevel1VO.totalForecastMonth7,
                          "8月": this.performancLevel1VO.totalForecastMonth8,
                          "9月": this.performancLevel1VO.totalForecastMonth9,
                          "10月": this.performancLevel1VO.totalForecastMonth10,
                          "11月": this.performancLevel1VO.totalForecastMonth11,
                          "12月": this.performancLevel1VO.totalForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.totalMonth1,
                             this.performancLevel1VO.totalMonth2,
                             this.performancLevel1VO.totalMonth3,
                              this.performancLevel1VO.totalMonth4,
                               this.performancLevel1VO.totalMonth5,
                               this.performancLevel1VO.totalMonth6,
                               this.performancLevel1VO.totalMonth7,
                                this.performancLevel1VO.totalMonth8,
                                 this.performancLevel1VO.totalMonth9,
                                 this.performancLevel1VO.totalMonth10,
                                  this.performancLevel1VO.totalMonth11];//目标值
                    this.dataarr2=[this.performancLevel1VO.totalSavingRateMonth1,
                               this.performancLevel1VO.totalSavingRateMonth2,
                               this.performancLevel1VO.totalSavingRateMonth3,
                               this.performancLevel1VO.totalSavingRateMonth4,
                               this.performancLevel1VO.totalSavingRateMonth5,
                               this.performancLevel1VO.totalSavingRateMonth6,
                                this.performancLevel1VO.totalSavingRateMonth7,
                                  this.performancLevel1VO.totalSavingRateMonth8,
                                  this.performancLevel1VO.totalSavingRateMonth9,
                                   this.performancLevel1VO.totalSavingRateMonth10,
                                   this.performancLevel1VO.totalSavingRateMonth11];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.totalCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.totalCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.totalCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.totalCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.totalCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.totalCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.totalCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.totalCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.totalCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.totalCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '11月',
                            name: this.performancLevel1VO.totalCompletionMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
             }
            // dataarr=
          }
             if(flag==1){
            //   alert(curmonth);
           //   alert( this.performancLevel1VO.powerMonth9);
          //     alert( this.performancLevel1VO.powerSavingRateMonth9);
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "2月": this.performancLevel1VO.powerForecastMonth2,
                        "3月": this.performancLevel1VO.powerForecastMonth3,
                        "4月": this.performancLevel1VO.powerForecastMonth4,
                        "5月": this.performancLevel1VO.powerForecastMonth5,
                         "6月": this.performancLevel1VO.powerForecastMonth6,
                          "7月": this.performancLevel1VO.powerForecastMonth7,
                          "8月": this.performancLevel1VO.powerForecastMonth8,
                          "9月": this.performancLevel1VO.powerForecastMonth9,
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                          "11月": this.performancLevel1VO.powerForecastMonth11,
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.powerCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.powerMonth1];//目标值
                  this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1];//实际值
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                      
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                      
                        "3月": this.performancLevel1VO.powerForecastMonth3,
                        "4月": this.performancLevel1VO.powerForecastMonth4,
                        "5月": this.performancLevel1VO.powerForecastMonth5,
                         "6月": this.performancLevel1VO.powerForecastMonth6,
                          "7月": this.performancLevel1VO.powerForecastMonth7,
                          "8月": this.performancLevel1VO.powerForecastMonth8,
                          "9月": this.performancLevel1VO.powerForecastMonth9,
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                          "11月": this.performancLevel1VO.powerForecastMonth11,
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2];//实际值
                    this.dataarr4=[this.performancLevel1VO.powerCompletionMonth1,
                              this.performancLevel1VO.powerCompletionMonth2];//评价
                     this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.powerCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  {
                    date: '2月',
                    name: this.performancLevel1VO.powerCompletionMonth2,
                   // image: require(besturl)
                    }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                   this.rightHeader=[
                       
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                    
                        "4月": this.performancLevel1VO.powerForecastMonth4,
                        "5月": this.performancLevel1VO.powerForecastMonth5,
                         "6月": this.performancLevel1VO.powerForecastMonth6,
                          "7月": this.performancLevel1VO.powerForecastMonth7,
                          "8月": this.performancLevel1VO.powerForecastMonth8,
                          "9月": this.performancLevel1VO.powerForecastMonth9,
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                          "11月": this.performancLevel1VO.powerForecastMonth11,
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ]; 
                     this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3];//实际值
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                        
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       
                        "5月": this.performancLevel1VO.powerForecastMonth5,
                         "6月": this.performancLevel1VO.powerForecastMonth6,
                          "7月": this.performancLevel1VO.powerForecastMonth7,
                          "8月": this.performancLevel1VO.powerForecastMonth8,
                          "9月": this.performancLevel1VO.powerForecastMonth9,
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                          "11月": this.performancLevel1VO.powerForecastMonth11,
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3,
                              this.performancLevel1VO.powerMonth4];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3,
                               this.performancLevel1VO.powerSavingRateMonth4];//实际值
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.powerCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                        
                         
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       
                       
                         "6月": this.performancLevel1VO.powerForecastMonth6,
                          "7月": this.performancLevel1VO.powerForecastMonth7,
                          "8月": this.performancLevel1VO.powerForecastMonth8,
                          "9月": this.performancLevel1VO.powerForecastMonth9,
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                          "11月": this.performancLevel1VO.powerForecastMonth11,
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3,
                              this.performancLevel1VO.powerMonth4,
                               this.performancLevel1VO.powerMonth5];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3,
                               this.performancLevel1VO.powerSavingRateMonth4,
                               this.performancLevel1VO.powerSavingRateMonth5];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.powerCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.powerCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 5:
                   this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                        
                        
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       
                       
                          "7月": this.performancLevel1VO.powerForecastMonth7,
                          "8月": this.performancLevel1VO.powerForecastMonth8,
                          "9月": this.performancLevel1VO.powerForecastMonth9,
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                          "11月": this.performancLevel1VO.powerForecastMonth11,
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3,
                              this.performancLevel1VO.powerMonth4,
                               this.performancLevel1VO.powerMonth5,
                               this.performancLevel1VO.powerMonth6];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3,
                               this.performancLevel1VO.powerSavingRateMonth4,
                               this.performancLevel1VO.powerSavingRateMonth5,
                               this.performancLevel1VO.powerSavingRateMonth6];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.powerCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.powerCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.powerCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 6:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                        
                        
                       
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       
                      
                          "8月": this.performancLevel1VO.powerForecastMonth8,
                          "9月": this.performancLevel1VO.powerForecastMonth9,
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                          "11月": this.performancLevel1VO.powerForecastMonth11,
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3,
                              this.performancLevel1VO.powerMonth4,
                               this.performancLevel1VO.powerMonth5,
                               this.performancLevel1VO.powerMonth6,
                               this.performancLevel1VO.powerMonth7];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3,
                               this.performancLevel1VO.powerSavingRateMonth4,
                               this.performancLevel1VO.powerSavingRateMonth5,
                               this.performancLevel1VO.powerSavingRateMonth6,
                                this.performancLevel1VO.powerSavingRateMonth7];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.powerCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.powerCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.powerCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.powerCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 7: 
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                    this.rightHeader=[
                        
                        
                       
                      
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       
                      
                 
                          "9月": this.performancLevel1VO.powerForecastMonth9,
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                          "11月": this.performancLevel1VO.powerForecastMonth11,
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3,
                              this.performancLevel1VO.powerMonth4,
                               this.performancLevel1VO.powerMonth5,
                               this.performancLevel1VO.powerMonth6,
                               this.performancLevel1VO.powerMonth7,
                                this.performancLevel1VO.powerMonth8];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3,
                               this.performancLevel1VO.powerSavingRateMonth4,
                               this.performancLevel1VO.powerSavingRateMonth5,
                               this.performancLevel1VO.powerSavingRateMonth6,
                                this.performancLevel1VO.powerSavingRateMonth7,
                                  this.performancLevel1VO.powerSavingRateMonth8];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.powerCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.powerCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.powerCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.powerCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.powerCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 8:
                 // alert( this.performancLevel1VO.powerMonth9);
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                    this.rightHeader=[
                        
                        
                       
                      
                        
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       
                      
                     
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                          "11月": this.performancLevel1VO.powerForecastMonth11,
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3,
                              this.performancLevel1VO.powerMonth4,
                               this.performancLevel1VO.powerMonth5,
                               this.performancLevel1VO.powerMonth6,
                               this.performancLevel1VO.powerMonth7,
                                this.performancLevel1VO.powerMonth8,
                                 this.performancLevel1VO.powerMonth9];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3,
                               this.performancLevel1VO.powerSavingRateMonth4,
                               this.performancLevel1VO.powerSavingRateMonth5,
                               this.performancLevel1VO.powerSavingRateMonth6,
                                this.performancLevel1VO.powerSavingRateMonth7,
                                  this.performancLevel1VO.powerSavingRateMonth8,
                                  this.performancLevel1VO.powerSavingRateMonth9];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.powerCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.powerCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.powerCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.powerCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.powerCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.powerCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                      // alert(111);
                             break;
                case 9:
           
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                    this.rightHeader=[
                        {
                          label: '1月',
                          key: '1月'
                          },
                         {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                  ];
                  this.rightsDate=[
                     {
                          
                      "1月": this.performancLevel1VO.powerForecastMonth1,
                      "2月": this.performancLevel1VO.powerForecastMonth2,
                        "3月": this.performancLevel1VO.powerForecastMonth3,
                        "4月": this.performancLevel1VO.powerForecastMonth4,
                        "5月": this.performancLevel1VO.powerForecastMonth5,
                         "6月": this.performancLevel1VO.powerForecastMonth6,
                          "7月": this.performancLevel1VO.powerForecastMonth7,
                          "8月": this.performancLevel1VO.powerForecastMonth8,
                          "9月": this.performancLevel1VO.powerForecastMonth9,
                          "10月": this.performancLevel1VO.powerForecastMonth10,
                       
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3,
                              this.performancLevel1VO.powerMonth4,
                               this.performancLevel1VO.powerMonth5,
                               this.performancLevel1VO.powerMonth6,
                               this.performancLevel1VO.powerMonth7,
                                this.performancLevel1VO.powerMonth8,
                                 this.performancLevel1VO.powerMonth9,
                                 this.performancLevel1VO.powerMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3,
                               this.performancLevel1VO.powerSavingRateMonth4,
                               this.performancLevel1VO.powerSavingRateMonth5,
                               this.performancLevel1VO.powerSavingRateMonth6,
                                this.performancLevel1VO.powerSavingRateMonth7,
                                  this.performancLevel1VO.powerSavingRateMonth8,
                                  this.performancLevel1VO.powerSavingRateMonth9,
                                   this.performancLevel1VO.powerSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.powerCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.powerCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.powerCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.powerCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.powerCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.powerCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.powerCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 10:
                   this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                    this.rightHeader=[
                        
                        
                       
                      
                  
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       
                      
                         
                     
                      
                     
                          "12月": this.performancLevel1VO.powerForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3,
                              this.performancLevel1VO.powerMonth4,
                               this.performancLevel1VO.powerMonth5,
                               this.performancLevel1VO.powerMonth6,
                               this.performancLevel1VO.powerMonth7,
                                this.performancLevel1VO.powerMonth8,
                                 this.performancLevel1VO.powerMonth9,
                                 this.performancLevel1VO.powerMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3,
                               this.performancLevel1VO.powerSavingRateMonth4,
                               this.performancLevel1VO.powerSavingRateMonth5,
                               this.performancLevel1VO.powerSavingRateMonth6,
                                this.performancLevel1VO.powerSavingRateMonth7,
                                  this.performancLevel1VO.powerSavingRateMonth8,
                                  this.performancLevel1VO.powerSavingRateMonth9,
                                   this.performancLevel1VO.powerSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.powerCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.powerCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.powerCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.powerCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.powerCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.powerCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.powerCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 11:
  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                    this.rightHeader=[
                        
                        
                       
                      
                  
                  ];
                  this.rightsDate=[
                     {
                       
                      
                         
                     
                      
                     
                         
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.powerMonth1,
                             this.performancLevel1VO.powerMonth2,
                             this.performancLevel1VO.powerMonth3,
                              this.performancLevel1VO.powerMonth4,
                               this.performancLevel1VO.powerMonth5,
                               this.performancLevel1VO.powerMonth6,
                               this.performancLevel1VO.powerMonth7,
                                this.performancLevel1VO.powerMonth8,
                                 this.performancLevel1VO.powerMonth9,
                                 this.performancLevel1VO.powerMonth10,
                                  this.performancLevel1VO.powerMonth11];//目标值
                    this.dataarr2=[this.performancLevel1VO.powerSavingRateMonth1,
                               this.performancLevel1VO.powerSavingRateMonth2,
                               this.performancLevel1VO.powerSavingRateMonth3,
                               this.performancLevel1VO.powerSavingRateMonth4,
                               this.performancLevel1VO.powerSavingRateMonth5,
                               this.performancLevel1VO.powerSavingRateMonth6,
                                this.performancLevel1VO.powerSavingRateMonth7,
                                  this.performancLevel1VO.powerSavingRateMonth8,
                                  this.performancLevel1VO.powerSavingRateMonth9,
                                   this.performancLevel1VO.powerSavingRateMonth10,
                                   this.performancLevel1VO.powerSavingRateMonth11];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.powerCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.powerCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.powerCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.powerCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.powerCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.powerCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.powerCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.powerCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.powerCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.powerCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '11月',
                            name: this.performancLevel1VO.powerCompletionMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
             }
            // dataarr=
          }
             if(flag==2){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          // {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                      //  "2月": this.performancLevel1VO.waterForecastMonth2,
                      //   "3月": this.performancLevel1VO.waterForecastMonth3,
                      //   "4月": this.performancLevel1VO.waterForecastMonth4,
                      //   "5月": this.performancLevel1VO.waterForecastMonth5,
                      //    "6月": this.performancLevel1VO.waterForecastMonth6,
                      //     "7月": this.performancLevel1VO.waterForecastMonth7,
                      //     "8月": this.performancLevel1VO.waterForecastMonth8,
                      //     "9月": this.performancLevel1VO.waterForecastMonth9,
                      //     "10月": this.performancLevel1VO.waterForecastMonth10,
                      //     "11月": this.performancLevel1VO.waterForecastMonth11,
                      //     "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.waterCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.waterMonth1];//目标值
                  this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1];//实际值
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        // "3月": this.performancLevel1VO.waterForecastMonth3,
                        // "4月": this.performancLevel1VO.waterForecastMonth4,
                        // "5月": this.performancLevel1VO.waterForecastMonth5,
                        //  "6月": this.performancLevel1VO.waterForecastMonth6,
                        //   "7月": this.performancLevel1VO.waterForecastMonth7,
                        //   "8月": this.performancLevel1VO.waterForecastMonth8,
                        //   "9月": this.performancLevel1VO.waterForecastMonth9,
                        //   "10月": this.performancLevel1VO.waterForecastMonth10,
                        //   "11月": this.performancLevel1VO.waterForecastMonth11,
                        //   "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2];//实际值
                    this.dataarr4=[this.performancLevel1VO.waterCompletionMonth1,
                              this.performancLevel1VO.waterCompletionMonth2];//评价
                     this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.waterCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  {
                    date: '2月',
                    name: this.performancLevel1VO.waterCompletionMonth2,
                   // image: require(besturl)
                    }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                  this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        // "4月": this.performancLevel1VO.waterForecastMonth4,
                        // "5月": this.performancLevel1VO.waterForecastMonth5,
                        //  "6月": this.performancLevel1VO.waterForecastMonth6,
                        //   "7月": this.performancLevel1VO.waterForecastMonth7,
                        //   "8月": this.performancLevel1VO.waterForecastMonth8,
                        //   "9月": this.performancLevel1VO.waterForecastMonth9,
                        //   "10月": this.performancLevel1VO.waterForecastMonth10,
                        //   "11月": this.performancLevel1VO.waterForecastMonth11,
                        //   "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                     this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3];//实际值
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        "4月": this.performancLevel1VO.waterForecastMonth4,
                        // "5月": this.performancLevel1VO.waterForecastMonth5,
                        //  "6月": this.performancLevel1VO.waterForecastMonth6,
                        //   "7月": this.performancLevel1VO.waterForecastMonth7,
                        //   "8月": this.performancLevel1VO.waterForecastMonth8,
                        //   "9月": this.performancLevel1VO.waterForecastMonth9,
                        //   "10月": this.performancLevel1VO.waterForecastMonth10,
                        //   "11月": this.performancLevel1VO.waterForecastMonth11,
                        //   "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3,
                              this.performancLevel1VO.waterMonth4];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3,
                               this.performancLevel1VO.waterSavingRateMonth4];//实际值
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.waterCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        "4月": this.performancLevel1VO.waterForecastMonth4,
                        "5月": this.performancLevel1VO.waterForecastMonth5,
                        //  "6月": this.performancLevel1VO.waterForecastMonth6,
                        //   "7月": this.performancLevel1VO.waterForecastMonth7,
                        //   "8月": this.performancLevel1VO.waterForecastMonth8,
                        //   "9月": this.performancLevel1VO.waterForecastMonth9,
                        //   "10月": this.performancLevel1VO.waterForecastMonth10,
                        //   "11月": this.performancLevel1VO.waterForecastMonth11,
                        //   "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3,
                              this.performancLevel1VO.waterMonth4,
                               this.performancLevel1VO.waterMonth5];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3,
                               this.performancLevel1VO.waterSavingRateMonth4,
                               this.performancLevel1VO.waterSavingRateMonth5];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.waterCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.waterCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 5:
                   this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        "4月": this.performancLevel1VO.waterForecastMonth4,
                        "5月": this.performancLevel1VO.waterForecastMonth5,
                         "6月": this.performancLevel1VO.waterForecastMonth6,
                          // "7月": this.performancLevel1VO.waterForecastMonth7,
                          // "8月": this.performancLevel1VO.waterForecastMonth8,
                          // "9月": this.performancLevel1VO.waterForecastMonth9,
                          // "10月": this.performancLevel1VO.waterForecastMonth10,
                          // "11月": this.performancLevel1VO.waterForecastMonth11,
                          // "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3,
                              this.performancLevel1VO.waterMonth4,
                               this.performancLevel1VO.waterMonth5,
                               this.performancLevel1VO.waterMonth6];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3,
                               this.performancLevel1VO.waterSavingRateMonth4,
                               this.performancLevel1VO.waterSavingRateMonth5,
                               this.performancLevel1VO.waterSavingRateMonth6];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.waterCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.waterCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.waterCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 6:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        "4月": this.performancLevel1VO.waterForecastMonth4,
                        "5月": this.performancLevel1VO.waterForecastMonth5,
                         "6月": this.performancLevel1VO.waterForecastMonth6,
                          "7月": this.performancLevel1VO.waterForecastMonth7,
                          // "8月": this.performancLevel1VO.waterForecastMonth8,
                          // "9月": this.performancLevel1VO.waterForecastMonth9,
                          // "10月": this.performancLevel1VO.waterForecastMonth10,
                          // "11月": this.performancLevel1VO.waterForecastMonth11,
                          // "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3,
                              this.performancLevel1VO.waterMonth4,
                               this.performancLevel1VO.waterMonth5,
                               this.performancLevel1VO.waterMonth6,
                               this.performancLevel1VO.waterMonth7];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3,
                               this.performancLevel1VO.waterSavingRateMonth4,
                               this.performancLevel1VO.waterSavingRateMonth5,
                               this.performancLevel1VO.waterSavingRateMonth6,
                                this.performancLevel1VO.waterSavingRateMonth7];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.waterCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.waterCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.waterCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.waterCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 7: 
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        "4月": this.performancLevel1VO.waterForecastMonth4,
                        "5月": this.performancLevel1VO.waterForecastMonth5,
                         "6月": this.performancLevel1VO.waterForecastMonth6,
                          "7月": this.performancLevel1VO.waterForecastMonth7,
                          "8月": this.performancLevel1VO.waterForecastMonth8,
                          // "9月": this.performancLevel1VO.waterForecastMonth9,
                          // "10月": this.performancLevel1VO.waterForecastMonth10,
                          // "11月": this.performancLevel1VO.waterForecastMonth11,
                          // "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3,
                              this.performancLevel1VO.waterMonth4,
                               this.performancLevel1VO.waterMonth5,
                               this.performancLevel1VO.waterMonth6,
                               this.performancLevel1VO.waterMonth7,
                                this.performancLevel1VO.waterMonth8];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3,
                               this.performancLevel1VO.waterSavingRateMonth4,
                               this.performancLevel1VO.waterSavingRateMonth5,
                               this.performancLevel1VO.waterSavingRateMonth6,
                                this.performancLevel1VO.waterSavingRateMonth7,
                                  this.performancLevel1VO.waterSavingRateMonth8];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.waterCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.waterCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.waterCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.waterCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.waterCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 8:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        "4月": this.performancLevel1VO.waterForecastMonth4,
                        "5月": this.performancLevel1VO.waterForecastMonth5,
                         "6月": this.performancLevel1VO.waterForecastMonth6,
                          "7月": this.performancLevel1VO.waterForecastMonth7,
                          "8月": this.performancLevel1VO.waterForecastMonth8,
                          "9月": this.performancLevel1VO.waterForecastMonth9,
                          // "10月": this.performancLevel1VO.waterForecastMonth10,
                          // "11月": this.performancLevel1VO.waterForecastMonth11,
                          // "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3,
                              this.performancLevel1VO.waterMonth4,
                               this.performancLevel1VO.waterMonth5,
                               this.performancLevel1VO.waterMonth6,
                               this.performancLevel1VO.waterMonth7,
                                this.performancLevel1VO.waterMonth8,
                                 this.performancLevel1VO.waterMonth9];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3,
                               this.performancLevel1VO.waterSavingRateMonth4,
                               this.performancLevel1VO.waterSavingRateMonth5,
                               this.performancLevel1VO.waterSavingRateMonth6,
                                this.performancLevel1VO.waterSavingRateMonth7,
                                  this.performancLevel1VO.waterSavingRateMonth8,
                                  this.performancLevel1VO.waterSavingRateMonth9];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.waterCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.waterCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.waterCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.waterCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.waterCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.waterCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 9:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                  this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        "4月": this.performancLevel1VO.waterForecastMonth4,
                        "5月": this.performancLevel1VO.waterForecastMonth5,
                         "6月": this.performancLevel1VO.waterForecastMonth6,
                          "7月": this.performancLevel1VO.waterForecastMonth7,
                          "8月": this.performancLevel1VO.waterForecastMonth8,
                          "9月": this.performancLevel1VO.waterForecastMonth9,
                          "10月": this.performancLevel1VO.waterForecastMonth10,
                          // "11月": this.performancLevel1VO.waterForecastMonth11,
                          // "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3,
                              this.performancLevel1VO.waterMonth4,
                               this.performancLevel1VO.waterMonth5,
                               this.performancLevel1VO.waterMonth6,
                               this.performancLevel1VO.waterMonth7,
                                this.performancLevel1VO.waterMonth8,
                                 this.performancLevel1VO.waterMonth9,
                                 this.performancLevel1VO.waterMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3,
                               this.performancLevel1VO.waterSavingRateMonth4,
                               this.performancLevel1VO.waterSavingRateMonth5,
                               this.performancLevel1VO.waterSavingRateMonth6,
                                this.performancLevel1VO.waterSavingRateMonth7,
                                  this.performancLevel1VO.waterSavingRateMonth8,
                                  this.performancLevel1VO.waterSavingRateMonth9,
                                   this.performancLevel1VO.waterSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.waterCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.waterCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.waterCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.waterCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.waterCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.waterCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.waterCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 10:
                   this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                   this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        "4月": this.performancLevel1VO.waterForecastMonth4,
                        "5月": this.performancLevel1VO.waterForecastMonth5,
                         "6月": this.performancLevel1VO.waterForecastMonth6,
                          "7月": this.performancLevel1VO.waterForecastMonth7,
                          "8月": this.performancLevel1VO.waterForecastMonth8,
                          "9月": this.performancLevel1VO.waterForecastMonth9,
                          "10月": this.performancLevel1VO.waterForecastMonth10,
                          "11月": this.performancLevel1VO.waterForecastMonth11,
                        //  "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3,
                              this.performancLevel1VO.waterMonth4,
                               this.performancLevel1VO.waterMonth5,
                               this.performancLevel1VO.waterMonth6,
                               this.performancLevel1VO.waterMonth7,
                                this.performancLevel1VO.waterMonth8,
                                 this.performancLevel1VO.waterMonth9,
                                 this.performancLevel1VO.waterMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3,
                               this.performancLevel1VO.waterSavingRateMonth4,
                               this.performancLevel1VO.waterSavingRateMonth5,
                               this.performancLevel1VO.waterSavingRateMonth6,
                                this.performancLevel1VO.waterSavingRateMonth7,
                                  this.performancLevel1VO.waterSavingRateMonth8,
                                  this.performancLevel1VO.waterSavingRateMonth9,
                                   this.performancLevel1VO.waterSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.waterCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.waterCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.waterCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.waterCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.waterCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.waterCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.waterCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 11:
  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.waterForecastMonth1,
                       "2月": this.performancLevel1VO.waterForecastMonth2,
                        "3月": this.performancLevel1VO.waterForecastMonth3,
                        "4月": this.performancLevel1VO.waterForecastMonth4,
                        "5月": this.performancLevel1VO.waterForecastMonth5,
                         "6月": this.performancLevel1VO.waterForecastMonth6,
                          "7月": this.performancLevel1VO.waterForecastMonth7,
                          "8月": this.performancLevel1VO.waterForecastMonth8,
                          "9月": this.performancLevel1VO.waterForecastMonth9,
                          "10月": this.performancLevel1VO.waterForecastMonth10,
                          "11月": this.performancLevel1VO.waterForecastMonth11,
                          "12月": this.performancLevel1VO.waterForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.waterMonth1,
                             this.performancLevel1VO.waterMonth2,
                             this.performancLevel1VO.waterMonth3,
                              this.performancLevel1VO.waterMonth4,
                               this.performancLevel1VO.waterMonth5,
                               this.performancLevel1VO.waterMonth6,
                               this.performancLevel1VO.waterMonth7,
                                this.performancLevel1VO.waterMonth8,
                                 this.performancLevel1VO.waterMonth9,
                                 this.performancLevel1VO.waterMonth10,
                                  this.performancLevel1VO.waterMonth11];//目标值
                    this.dataarr2=[this.performancLevel1VO.waterSavingRateMonth1,
                               this.performancLevel1VO.waterSavingRateMonth2,
                               this.performancLevel1VO.waterSavingRateMonth3,
                               this.performancLevel1VO.waterSavingRateMonth4,
                               this.performancLevel1VO.waterSavingRateMonth5,
                               this.performancLevel1VO.waterSavingRateMonth6,
                                this.performancLevel1VO.waterSavingRateMonth7,
                                  this.performancLevel1VO.waterSavingRateMonth8,
                                  this.performancLevel1VO.waterSavingRateMonth9,
                                   this.performancLevel1VO.waterSavingRateMonth10,
                                   this.performancLevel1VO.waterSavingRateMonth11];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.waterCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.waterCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.waterCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.waterCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.waterCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.waterCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.waterCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.waterCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.waterCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.waterCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '11月',
                            name: this.performancLevel1VO.waterCompletionMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
             }
            // dataarr=
          }
             if(flag==3){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          // {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        // "2月": this.performancLevel1VO.gasForecastMonth2,
                        // "3月": this.performancLevel1VO.gasForecastMonth3,
                        // "4月": this.performancLevel1VO.gasForecastMonth4,
                        // "5月": this.performancLevel1VO.gasForecastMonth5,
                        //  "6月": this.performancLevel1VO.gasForecastMonth6,
                        //   "7月": this.performancLevel1VO.gasForecastMonth7,
                        //   "8月": this.performancLevel1VO.gasForecastMonth8,
                        //   "9月": this.performancLevel1VO.gasForecastMonth9,
                        //   "10月": this.performancLevel1VO.gasForecastMonth10,
                        //   "11月": this.performancLevel1VO.gasForecastMonth11,
                        //   "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.gasCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.gasMonth1];//目标值
                  this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1];//实际值
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        // "3月": this.performancLevel1VO.gasForecastMonth3,
                        // "4月": this.performancLevel1VO.gasForecastMonth4,
                        // "5月": this.performancLevel1VO.gasForecastMonth5,
                        //  "6月": this.performancLevel1VO.gasForecastMonth6,
                        //   "7月": this.performancLevel1VO.gasForecastMonth7,
                        //   "8月": this.performancLevel1VO.gasForecastMonth8,
                        //   "9月": this.performancLevel1VO.gasForecastMonth9,
                        //   "10月": this.performancLevel1VO.gasForecastMonth10,
                        //   "11月": this.performancLevel1VO.gasForecastMonth11,
                        //   "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2];//实际值
                    this.dataarr4=[this.performancLevel1VO.gasCompletionMonth1,
                              this.performancLevel1VO.gasCompletionMonth2];//评价
                     this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.gasCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  {
                    date: '2月',
                    name: this.performancLevel1VO.gasCompletionMonth2,
                   // image: require(besturl)
                    }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        // "4月": this.performancLevel1VO.gasForecastMonth4,
                        // "5月": this.performancLevel1VO.gasForecastMonth5,
                        //  "6月": this.performancLevel1VO.gasForecastMonth6,
                        //   "7月": this.performancLevel1VO.gasForecastMonth7,
                        //   "8月": this.performancLevel1VO.gasForecastMonth8,
                        //   "9月": this.performancLevel1VO.gasForecastMonth9,
                        //   "10月": this.performancLevel1VO.gasForecastMonth10,
                        //   "11月": this.performancLevel1VO.gasForecastMonth11,
                        //   "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                     this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3];//实际值
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        "4月": this.performancLevel1VO.gasForecastMonth4,
                        // "5月": this.performancLevel1VO.gasForecastMonth5,
                        //  "6月": this.performancLevel1VO.gasForecastMonth6,
                        //   "7月": this.performancLevel1VO.gasForecastMonth7,
                        //   "8月": this.performancLevel1VO.gasForecastMonth8,
                        //   "9月": this.performancLevel1VO.gasForecastMonth9,
                        //   "10月": this.performancLevel1VO.gasForecastMonth10,
                        //   "11月": this.performancLevel1VO.gasForecastMonth11,
                        //   "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3,
                              this.performancLevel1VO.gasMonth4];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3,
                               this.performancLevel1VO.gasSavingRateMonth4];//实际值
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.gasCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                      this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        "4月": this.performancLevel1VO.gasForecastMonth4,
                        "5月": this.performancLevel1VO.gasForecastMonth5,
                        //  "6月": this.performancLevel1VO.gasForecastMonth6,
                        //   "7月": this.performancLevel1VO.gasForecastMonth7,
                        //   "8月": this.performancLevel1VO.gasForecastMonth8,
                        //   "9月": this.performancLevel1VO.gasForecastMonth9,
                        //   "10月": this.performancLevel1VO.gasForecastMonth10,
                        //   "11月": this.performancLevel1VO.gasForecastMonth11,
                        //   "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3,
                              this.performancLevel1VO.gasMonth4,
                               this.performancLevel1VO.gasMonth5];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3,
                               this.performancLevel1VO.gasSavingRateMonth4,
                               this.performancLevel1VO.gasSavingRateMonth5];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.gasCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.gasCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 5:
                   this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        "4月": this.performancLevel1VO.gasForecastMonth4,
                        "5月": this.performancLevel1VO.gasForecastMonth5,
                         "6月": this.performancLevel1VO.gasForecastMonth6,
                          // "7月": this.performancLevel1VO.gasForecastMonth7,
                          // "8月": this.performancLevel1VO.gasForecastMonth8,
                          // "9月": this.performancLevel1VO.gasForecastMonth9,
                          // "10月": this.performancLevel1VO.gasForecastMonth10,
                          // "11月": this.performancLevel1VO.gasForecastMonth11,
                          // "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3,
                              this.performancLevel1VO.gasMonth4,
                               this.performancLevel1VO.gasMonth5,
                               this.performancLevel1VO.gasMonth6];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3,
                               this.performancLevel1VO.gasSavingRateMonth4,
                               this.performancLevel1VO.gasSavingRateMonth5,
                               this.performancLevel1VO.gasSavingRateMonth6];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.gasCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.gasCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.gasCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 6:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        "4月": this.performancLevel1VO.gasForecastMonth4,
                        "5月": this.performancLevel1VO.gasForecastMonth5,
                         "6月": this.performancLevel1VO.gasForecastMonth6,
                          "7月": this.performancLevel1VO.gasForecastMonth7,
                          // "8月": this.performancLevel1VO.gasForecastMonth8,
                          // "9月": this.performancLevel1VO.gasForecastMonth9,
                          // "10月": this.performancLevel1VO.gasForecastMonth10,
                          // "11月": this.performancLevel1VO.gasForecastMonth11,
                          // "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3,
                              this.performancLevel1VO.gasMonth4,
                               this.performancLevel1VO.gasMonth5,
                               this.performancLevel1VO.gasMonth6,
                               this.performancLevel1VO.gasMonth7];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3,
                               this.performancLevel1VO.gasSavingRateMonth4,
                               this.performancLevel1VO.gasSavingRateMonth5,
                               this.performancLevel1VO.gasSavingRateMonth6,
                                this.performancLevel1VO.gasSavingRateMonth7];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.gasCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.gasCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.gasCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.gasCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 7: 
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        "4月": this.performancLevel1VO.gasForecastMonth4,
                        "5月": this.performancLevel1VO.gasForecastMonth5,
                         "6月": this.performancLevel1VO.gasForecastMonth6,
                          "7月": this.performancLevel1VO.gasForecastMonth7,
                          "8月": this.performancLevel1VO.gasForecastMonth8,
                          // "9月": this.performancLevel1VO.gasForecastMonth9,
                          // "10月": this.performancLevel1VO.gasForecastMonth10,
                          // "11月": this.performancLevel1VO.gasForecastMonth11,
                          // "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3,
                              this.performancLevel1VO.gasMonth4,
                               this.performancLevel1VO.gasMonth5,
                               this.performancLevel1VO.gasMonth6,
                               this.performancLevel1VO.gasMonth7,
                                this.performancLevel1VO.gasMonth8];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3,
                               this.performancLevel1VO.gasSavingRateMonth4,
                               this.performancLevel1VO.gasSavingRateMonth5,
                               this.performancLevel1VO.gasSavingRateMonth6,
                                this.performancLevel1VO.gasSavingRateMonth7,
                                  this.performancLevel1VO.gasSavingRateMonth8];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.gasCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.gasCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.gasCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.gasCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.gasCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 8:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        "4月": this.performancLevel1VO.gasForecastMonth4,
                        "5月": this.performancLevel1VO.gasForecastMonth5,
                         "6月": this.performancLevel1VO.gasForecastMonth6,
                          "7月": this.performancLevel1VO.gasForecastMonth7,
                          "8月": this.performancLevel1VO.gasForecastMonth8,
                          "9月": this.performancLevel1VO.gasForecastMonth9,
                          // "10月": this.performancLevel1VO.gasForecastMonth10,
                          // "11月": this.performancLevel1VO.gasForecastMonth11,
                          // "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3,
                              this.performancLevel1VO.gasMonth4,
                               this.performancLevel1VO.gasMonth5,
                               this.performancLevel1VO.gasMonth6,
                               this.performancLevel1VO.gasMonth7,
                                this.performancLevel1VO.gasMonth8,
                                 this.performancLevel1VO.gasMonth9];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3,
                               this.performancLevel1VO.gasSavingRateMonth4,
                               this.performancLevel1VO.gasSavingRateMonth5,
                               this.performancLevel1VO.gasSavingRateMonth6,
                                this.performancLevel1VO.gasSavingRateMonth7,
                                  this.performancLevel1VO.gasSavingRateMonth8,
                                  this.performancLevel1VO.gasSavingRateMonth9];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.gasCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.gasCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.gasCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.gasCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.gasCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.gasCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 9:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                    this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        "4月": this.performancLevel1VO.gasForecastMonth4,
                        "5月": this.performancLevel1VO.gasForecastMonth5,
                         "6月": this.performancLevel1VO.gasForecastMonth6,
                          "7月": this.performancLevel1VO.gasForecastMonth7,
                          "8月": this.performancLevel1VO.gasForecastMonth8,
                          "9月": this.performancLevel1VO.gasForecastMonth9,
                          "10月": this.performancLevel1VO.gasForecastMonth10,
                          // "11月": this.performancLevel1VO.gasForecastMonth11,
                          // "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3,
                              this.performancLevel1VO.gasMonth4,
                               this.performancLevel1VO.gasMonth5,
                               this.performancLevel1VO.gasMonth6,
                               this.performancLevel1VO.gasMonth7,
                                this.performancLevel1VO.gasMonth8,
                                 this.performancLevel1VO.gasMonth9,
                                 this.performancLevel1VO.gasMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3,
                               this.performancLevel1VO.gasSavingRateMonth4,
                               this.performancLevel1VO.gasSavingRateMonth5,
                               this.performancLevel1VO.gasSavingRateMonth6,
                                this.performancLevel1VO.gasSavingRateMonth7,
                                  this.performancLevel1VO.gasSavingRateMonth8,
                                  this.performancLevel1VO.gasSavingRateMonth9,
                                   this.performancLevel1VO.gasSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.gasCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.gasCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.gasCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.gasCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.gasCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.gasCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.gasCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 10:
                   this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        "4月": this.performancLevel1VO.gasForecastMonth4,
                        "5月": this.performancLevel1VO.gasForecastMonth5,
                         "6月": this.performancLevel1VO.gasForecastMonth6,
                          "7月": this.performancLevel1VO.gasForecastMonth7,
                          "8月": this.performancLevel1VO.gasForecastMonth8,
                          "9月": this.performancLevel1VO.gasForecastMonth9,
                          "10月": this.performancLevel1VO.gasForecastMonth10,
                          "11月": this.performancLevel1VO.gasForecastMonth11,
                        //  "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3,
                              this.performancLevel1VO.gasMonth4,
                               this.performancLevel1VO.gasMonth5,
                               this.performancLevel1VO.gasMonth6,
                               this.performancLevel1VO.gasMonth7,
                                this.performancLevel1VO.gasMonth8,
                                 this.performancLevel1VO.gasMonth9,
                                 this.performancLevel1VO.gasMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3,
                               this.performancLevel1VO.gasSavingRateMonth4,
                               this.performancLevel1VO.gasSavingRateMonth5,
                               this.performancLevel1VO.gasSavingRateMonth6,
                                this.performancLevel1VO.gasSavingRateMonth7,
                                  this.performancLevel1VO.gasSavingRateMonth8,
                                  this.performancLevel1VO.gasSavingRateMonth9,
                                   this.performancLevel1VO.gasSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.gasCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.gasCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.gasCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.gasCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.gasCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.gasCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.gasCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 11:
  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                     this.rightHeader=[
                     {
                          label: '1月',
                          key: '1月'
                          },
                          {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.gasForecastMonth1,
                        "2月": this.performancLevel1VO.gasForecastMonth2,
                        "3月": this.performancLevel1VO.gasForecastMonth3,
                        "4月": this.performancLevel1VO.gasForecastMonth4,
                        "5月": this.performancLevel1VO.gasForecastMonth5,
                         "6月": this.performancLevel1VO.gasForecastMonth6,
                          "7月": this.performancLevel1VO.gasForecastMonth7,
                          "8月": this.performancLevel1VO.gasForecastMonth8,
                          "9月": this.performancLevel1VO.gasForecastMonth9,
                          "10月": this.performancLevel1VO.gasForecastMonth10,
                          "11月": this.performancLevel1VO.gasForecastMonth11,
                          "12月": this.performancLevel1VO.gasForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.gasMonth1,
                             this.performancLevel1VO.gasMonth2,
                             this.performancLevel1VO.gasMonth3,
                              this.performancLevel1VO.gasMonth4,
                               this.performancLevel1VO.gasMonth5,
                               this.performancLevel1VO.gasMonth6,
                               this.performancLevel1VO.gasMonth7,
                                this.performancLevel1VO.gasMonth8,
                                 this.performancLevel1VO.gasMonth9,
                                 this.performancLevel1VO.gasMonth10,
                                  this.performancLevel1VO.gasMonth11];//目标值
                    this.dataarr2=[this.performancLevel1VO.gasSavingRateMonth1,
                               this.performancLevel1VO.gasSavingRateMonth2,
                               this.performancLevel1VO.gasSavingRateMonth3,
                               this.performancLevel1VO.gasSavingRateMonth4,
                               this.performancLevel1VO.gasSavingRateMonth5,
                               this.performancLevel1VO.gasSavingRateMonth6,
                                this.performancLevel1VO.gasSavingRateMonth7,
                                  this.performancLevel1VO.gasSavingRateMonth8,
                                  this.performancLevel1VO.gasSavingRateMonth9,
                                   this.performancLevel1VO.gasSavingRateMonth10,
                                   this.performancLevel1VO.gasSavingRateMonth11];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.gasCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.gasCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.gasCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.gasCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.gasCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.gasCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.gasCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.gasCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.gasCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.gasCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '11月',
                            name: this.performancLevel1VO.gasCompletionMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
             }
            // dataarr=
          }
             if(flag==4){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //  {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                      //  "2月": this.performancLevel1VO.hotForecastMonth2,
                      //   "3月": this.performancLevel1VO.hotForecastMonth3,
                      //   "4月": this.performancLevel1VO.hotForecastMonth4,
                      //   "5月": this.performancLevel1VO.hotForecastMonth5,
                      //    "6月": this.performancLevel1VO.hotForecastMonth6,
                      //     "7月": this.performancLevel1VO.hotForecastMonth7,
                      //     "8月": this.performancLevel1VO.hotForecastMonth8,
                      //     "9月": this.performancLevel1VO.hotForecastMonth9,
                      //     "10月": this.performancLevel1VO.hotForecastMonth10,
                      //     "11月": this.performancLevel1VO.hotForecastMonth11,
                      //     "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.hotCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.hotMonth1];//目标值
                  this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1];//实际值
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        // "3月": this.performancLevel1VO.hotForecastMonth3,
                        // "4月": this.performancLevel1VO.hotForecastMonth4,
                        // "5月": this.performancLevel1VO.hotForecastMonth5,
                        //  "6月": this.performancLevel1VO.hotForecastMonth6,
                        //   "7月": this.performancLevel1VO.hotForecastMonth7,
                        //   "8月": this.performancLevel1VO.hotForecastMonth8,
                        //   "9月": this.performancLevel1VO.hotForecastMonth9,
                        //   "10月": this.performancLevel1VO.hotForecastMonth10,
                        //   "11月": this.performancLevel1VO.hotForecastMonth11,
                        //   "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2];//实际值
                    this.dataarr4=[this.performancLevel1VO.hotCompletionMonth1,
                              this.performancLevel1VO.hotCompletionMonth2];//评价
                     this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.hotCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  {
                    date: '2月',
                    name: this.performancLevel1VO.hotCompletionMonth2,
                   // image: require(besturl)
                    }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        // "4月": this.performancLevel1VO.hotForecastMonth4,
                        // "5月": this.performancLevel1VO.hotForecastMonth5,
                        //  "6月": this.performancLevel1VO.hotForecastMonth6,
                        //   "7月": this.performancLevel1VO.hotForecastMonth7,
                        //   "8月": this.performancLevel1VO.hotForecastMonth8,
                        //   "9月": this.performancLevel1VO.hotForecastMonth9,
                        //   "10月": this.performancLevel1VO.hotForecastMonth10,
                        //   "11月": this.performancLevel1VO.hotForecastMonth11,
                        //   "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                     this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3];//实际值
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        "4月": this.performancLevel1VO.hotForecastMonth4,
                        // "5月": this.performancLevel1VO.hotForecastMonth5,
                        //  "6月": this.performancLevel1VO.hotForecastMonth6,
                        //   "7月": this.performancLevel1VO.hotForecastMonth7,
                        //   "8月": this.performancLevel1VO.hotForecastMonth8,
                        //   "9月": this.performancLevel1VO.hotForecastMonth9,
                        //   "10月": this.performancLevel1VO.hotForecastMonth10,
                        //   "11月": this.performancLevel1VO.hotForecastMonth11,
                        //   "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3,
                              this.performancLevel1VO.hotMonth4];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3,
                               this.performancLevel1VO.hotSavingRateMonth4];//实际值
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.hotCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        "4月": this.performancLevel1VO.hotForecastMonth4,
                        "5月": this.performancLevel1VO.hotForecastMonth5,
                        //  "6月": this.performancLevel1VO.hotForecastMonth6,
                        //   "7月": this.performancLevel1VO.hotForecastMonth7,
                        //   "8月": this.performancLevel1VO.hotForecastMonth8,
                        //   "9月": this.performancLevel1VO.hotForecastMonth9,
                        //   "10月": this.performancLevel1VO.hotForecastMonth10,
                        //   "11月": this.performancLevel1VO.hotForecastMonth11,
                        //   "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3,
                              this.performancLevel1VO.hotMonth4,
                               this.performancLevel1VO.hotMonth5];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3,
                               this.performancLevel1VO.hotSavingRateMonth4,
                               this.performancLevel1VO.hotSavingRateMonth5];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.hotCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.hotCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 5:
                   this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        "4月": this.performancLevel1VO.hotForecastMonth4,
                        "5月": this.performancLevel1VO.hotForecastMonth5,
                         "6月": this.performancLevel1VO.hotForecastMonth6,
                          // "7月": this.performancLevel1VO.hotForecastMonth7,
                          // "8月": this.performancLevel1VO.hotForecastMonth8,
                          // "9月": this.performancLevel1VO.hotForecastMonth9,
                          // "10月": this.performancLevel1VO.hotForecastMonth10,
                          // "11月": this.performancLevel1VO.hotForecastMonth11,
                          // "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3,
                              this.performancLevel1VO.hotMonth4,
                               this.performancLevel1VO.hotMonth5,
                               this.performancLevel1VO.hotMonth6];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3,
                               this.performancLevel1VO.hotSavingRateMonth4,
                               this.performancLevel1VO.hotSavingRateMonth5,
                               this.performancLevel1VO.hotSavingRateMonth6];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.hotCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.hotCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.hotCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 6:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        "4月": this.performancLevel1VO.hotForecastMonth4,
                        "5月": this.performancLevel1VO.hotForecastMonth5,
                         "6月": this.performancLevel1VO.hotForecastMonth6,
                           "7月": this.performancLevel1VO.hotForecastMonth7,
                          // "8月": this.performancLevel1VO.hotForecastMonth8,
                          // "9月": this.performancLevel1VO.hotForecastMonth9,
                          // "10月": this.performancLevel1VO.hotForecastMonth10,
                          // "11月": this.performancLevel1VO.hotForecastMonth11,
                          // "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3,
                              this.performancLevel1VO.hotMonth4,
                               this.performancLevel1VO.hotMonth5,
                               this.performancLevel1VO.hotMonth6,
                               this.performancLevel1VO.hotMonth7];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3,
                               this.performancLevel1VO.hotSavingRateMonth4,
                               this.performancLevel1VO.hotSavingRateMonth5,
                               this.performancLevel1VO.hotSavingRateMonth6,
                                this.performancLevel1VO.hotSavingRateMonth7];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.hotCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.hotCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.hotCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.hotCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 7: 
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        "4月": this.performancLevel1VO.hotForecastMonth4,
                        "5月": this.performancLevel1VO.hotForecastMonth5,
                         "6月": this.performancLevel1VO.hotForecastMonth6,
                          "7月": this.performancLevel1VO.hotForecastMonth7,
                          "8月": this.performancLevel1VO.hotForecastMonth8,
                          // "9月": this.performancLevel1VO.hotForecastMonth9,
                          // "10月": this.performancLevel1VO.hotForecastMonth10,
                          // "11月": this.performancLevel1VO.hotForecastMonth11,
                          // "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3,
                              this.performancLevel1VO.hotMonth4,
                               this.performancLevel1VO.hotMonth5,
                               this.performancLevel1VO.hotMonth6,
                               this.performancLevel1VO.hotMonth7,
                                this.performancLevel1VO.hotMonth8];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3,
                               this.performancLevel1VO.hotSavingRateMonth4,
                               this.performancLevel1VO.hotSavingRateMonth5,
                               this.performancLevel1VO.hotSavingRateMonth6,
                                this.performancLevel1VO.hotSavingRateMonth7,
                                  this.performancLevel1VO.hotSavingRateMonth8];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.hotCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.hotCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.hotCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.hotCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.hotCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 8:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        "4月": this.performancLevel1VO.hotForecastMonth4,
                        "5月": this.performancLevel1VO.hotForecastMonth5,
                         "6月": this.performancLevel1VO.hotForecastMonth6,
                          "7月": this.performancLevel1VO.hotForecastMonth7,
                          "8月": this.performancLevel1VO.hotForecastMonth8,
                          "9月": this.performancLevel1VO.hotForecastMonth9,
                          // "10月": this.performancLevel1VO.hotForecastMonth10,
                          // "11月": this.performancLevel1VO.hotForecastMonth11,
                          // "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3,
                              this.performancLevel1VO.hotMonth4,
                               this.performancLevel1VO.hotMonth5,
                               this.performancLevel1VO.hotMonth6,
                               this.performancLevel1VO.hotMonth7,
                                this.performancLevel1VO.hotMonth8,
                                 this.performancLevel1VO.hotMonth9];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3,
                               this.performancLevel1VO.hotSavingRateMonth4,
                               this.performancLevel1VO.hotSavingRateMonth5,
                               this.performancLevel1VO.hotSavingRateMonth6,
                                this.performancLevel1VO.hotSavingRateMonth7,
                                  this.performancLevel1VO.hotSavingRateMonth8,
                                  this.performancLevel1VO.hotSavingRateMonth9];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.hotCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.hotCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.hotCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.hotCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.hotCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.hotCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 9:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                     this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        "4月": this.performancLevel1VO.hotForecastMonth4,
                        "5月": this.performancLevel1VO.hotForecastMonth5,
                         "6月": this.performancLevel1VO.hotForecastMonth6,
                          "7月": this.performancLevel1VO.hotForecastMonth7,
                          "8月": this.performancLevel1VO.hotForecastMonth8,
                          "9月": this.performancLevel1VO.hotForecastMonth9,
                          "10月": this.performancLevel1VO.hotForecastMonth10,
                          // "11月": this.performancLevel1VO.hotForecastMonth11,
                          // "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3,
                              this.performancLevel1VO.hotMonth4,
                               this.performancLevel1VO.hotMonth5,
                               this.performancLevel1VO.hotMonth6,
                               this.performancLevel1VO.hotMonth7,
                                this.performancLevel1VO.hotMonth8,
                                 this.performancLevel1VO.hotMonth9,
                                 this.performancLevel1VO.hotMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3,
                               this.performancLevel1VO.hotSavingRateMonth4,
                               this.performancLevel1VO.hotSavingRateMonth5,
                               this.performancLevel1VO.hotSavingRateMonth6,
                                this.performancLevel1VO.hotSavingRateMonth7,
                                  this.performancLevel1VO.hotSavingRateMonth8,
                                  this.performancLevel1VO.hotSavingRateMonth9,
                                   this.performancLevel1VO.hotSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.hotCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.hotCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.hotCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.hotCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.hotCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.hotCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.hotCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 10:
                   this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        "4月": this.performancLevel1VO.hotForecastMonth4,
                        "5月": this.performancLevel1VO.hotForecastMonth5,
                         "6月": this.performancLevel1VO.hotForecastMonth6,
                          "7月": this.performancLevel1VO.hotForecastMonth7,
                          "8月": this.performancLevel1VO.hotForecastMonth8,
                          "9月": this.performancLevel1VO.hotForecastMonth9,
                          "10月": this.performancLevel1VO.hotForecastMonth10,
                          "11月": this.performancLevel1VO.hotForecastMonth11,
                         // "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3,
                              this.performancLevel1VO.hotMonth4,
                               this.performancLevel1VO.hotMonth5,
                               this.performancLevel1VO.hotMonth6,
                               this.performancLevel1VO.hotMonth7,
                                this.performancLevel1VO.hotMonth8,
                                 this.performancLevel1VO.hotMonth9,
                                 this.performancLevel1VO.hotMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3,
                               this.performancLevel1VO.hotSavingRateMonth4,
                               this.performancLevel1VO.hotSavingRateMonth5,
                               this.performancLevel1VO.hotSavingRateMonth6,
                                this.performancLevel1VO.hotSavingRateMonth7,
                                  this.performancLevel1VO.hotSavingRateMonth8,
                                  this.performancLevel1VO.hotSavingRateMonth9,
                                   this.performancLevel1VO.hotSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.hotCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.hotCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.hotCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.hotCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.hotCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.hotCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.hotCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 11:
  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.hotForecastMonth1,
                       "2月": this.performancLevel1VO.hotForecastMonth2,
                        "3月": this.performancLevel1VO.hotForecastMonth3,
                        "4月": this.performancLevel1VO.hotForecastMonth4,
                        "5月": this.performancLevel1VO.hotForecastMonth5,
                         "6月": this.performancLevel1VO.hotForecastMonth6,
                          "7月": this.performancLevel1VO.hotForecastMonth7,
                          "8月": this.performancLevel1VO.hotForecastMonth8,
                          "9月": this.performancLevel1VO.hotForecastMonth9,
                          "10月": this.performancLevel1VO.hotForecastMonth10,
                          "11月": this.performancLevel1VO.hotForecastMonth11,
                          "12月": this.performancLevel1VO.hotForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.hotMonth1,
                             this.performancLevel1VO.hotMonth2,
                             this.performancLevel1VO.hotMonth3,
                              this.performancLevel1VO.hotMonth4,
                               this.performancLevel1VO.hotMonth5,
                               this.performancLevel1VO.hotMonth6,
                               this.performancLevel1VO.hotMonth7,
                                this.performancLevel1VO.hotMonth8,
                                 this.performancLevel1VO.hotMonth9,
                                 this.performancLevel1VO.hotMonth10,
                                  this.performancLevel1VO.hotMonth11];//目标值
                    this.dataarr2=[this.performancLevel1VO.hotSavingRateMonth1,
                               this.performancLevel1VO.hotSavingRateMonth2,
                               this.performancLevel1VO.hotSavingRateMonth3,
                               this.performancLevel1VO.hotSavingRateMonth4,
                               this.performancLevel1VO.hotSavingRateMonth5,
                               this.performancLevel1VO.hotSavingRateMonth6,
                                this.performancLevel1VO.hotSavingRateMonth7,
                                  this.performancLevel1VO.hotSavingRateMonth8,
                                  this.performancLevel1VO.hotSavingRateMonth9,
                                   this.performancLevel1VO.hotSavingRateMonth10,
                                   this.performancLevel1VO.hotSavingRateMonth11];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.hotCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.hotCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.hotCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.hotCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.hotCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.hotCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.hotCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.hotCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.hotCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.hotCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '11月',
                            name: this.performancLevel1VO.hotCompletionMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
             }
            // dataarr=
          }
             if(flag==5){
             switch(curmonth){
                case 0:
                  this.montharr=["1月"];
                  this.montharr2=["2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                  this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                          //  {
                          // label: '2月',
                          // key: '2月'
                          // },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                      //  "2月": this.performancLevel1VO.othersForecastMonth2,
                      //   "3月": this.performancLevel1VO.othersForecastMonth3,
                      //   "4月": this.performancLevel1VO.othersForecastMonth4,
                      //   "5月": this.performancLevel1VO.othersForecastMonth5,
                      //    "6月": this.performancLevel1VO.othersForecastMonth6,
                      //     "7月": this.performancLevel1VO.othersForecastMonth7,
                      //     "8月": this.performancLevel1VO.othersForecastMonth8,
                      //     "9月": this.performancLevel1VO.othersForecastMonth9,
                      //     "10月": this.performancLevel1VO.othersForecastMonth10,
                      //     "11月": this.performancLevel1VO.othersForecastMonth11,
                      //     "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                  this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.othersCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.othersMonth1];//目标值
                  this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1];//实际值
                  
                             break;
                  
                case 1: 
                  this.montharr=["1月","2月"];
                   this.montharr2=["3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          // {
                          // label: '3月',
                          // key: '3月'
                          // },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        // "3月": this.performancLevel1VO.othersForecastMonth3,
                        // "4月": this.performancLevel1VO.othersForecastMonth4,
                        // "5月": this.performancLevel1VO.othersForecastMonth5,
                        //  "6月": this.performancLevel1VO.othersForecastMonth6,
                        //   "7月": this.performancLevel1VO.othersForecastMonth7,
                        //   "8月": this.performancLevel1VO.othersForecastMonth8,
                        //   "9月": this.performancLevel1VO.othersForecastMonth9,
                        //   "10月": this.performancLevel1VO.othersForecastMonth10,
                        //   "11月": this.performancLevel1VO.othersForecastMonth11,
                        //   "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2];//实际值
                    this.dataarr4=[this.performancLevel1VO.othersCompletionMonth1,
                              this.performancLevel1VO.othersCompletionMonth2];//评价
                     this.tableData=[{
                    date: '1月',
                    name: this.performancLevel1VO.othersCompletionMonth1,
                    //image: require(besturl)
                    }, 
                  {
                    date: '2月',
                    name: this.performancLevel1VO.othersCompletionMonth2,
                   // image: require(besturl)
                    }, 
                  ];         
                   
                             break;
                case 2:
                  this.montharr=["1月","2月","3月"];        
                   this.montharr2=["4月","5月","6月","7月","8月","9月","10月","11月","12月"]; 
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          // {
                          // label: '4月',
                          // key: '4月'
                          // },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        // "4月": this.performancLevel1VO.othersForecastMonth4,
                        // "5月": this.performancLevel1VO.othersForecastMonth5,
                        //  "6月": this.performancLevel1VO.othersForecastMonth6,
                        //   "7月": this.performancLevel1VO.othersForecastMonth7,
                        //   "8月": this.performancLevel1VO.othersForecastMonth8,
                        //   "9月": this.performancLevel1VO.othersForecastMonth9,
                        //   "10月": this.performancLevel1VO.othersForecastMonth10,
                        //   "11月": this.performancLevel1VO.othersForecastMonth11,
                        //   "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                     this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3];//实际值
                   
                     this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                   
                            break;
                case 3:
                 // alert(this.montharr);
                  this.montharr=["1月","2月","3月","4月"];
                   this.montharr2=["5月","6月","7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          // {
                          // label: '5月',
                          // key: '5月'
                          // },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        "4月": this.performancLevel1VO.othersForecastMonth4,
                        // "5月": this.performancLevel1VO.othersForecastMonth5,
                        //  "6月": this.performancLevel1VO.othersForecastMonth6,
                        //   "7月": this.performancLevel1VO.othersForecastMonth7,
                        //   "8月": this.performancLevel1VO.othersForecastMonth8,
                        //   "9月": this.performancLevel1VO.othersForecastMonth9,
                        //   "10月": this.performancLevel1VO.othersForecastMonth10,
                        //   "11月": this.performancLevel1VO.othersForecastMonth11,
                        //   "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3,
                              this.performancLevel1VO.othersMonth4];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3,
                               this.performancLevel1VO.othersSavingRateMonth4];//实际值
                 this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.othersCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                    
                    
                             break;
                case 4:
                  this.montharr=["1月","2月","3月","4月","5月"];
                   this.montharr2=["6月","7月","8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          // {
                          // label: '6月',
                          // key: '6月'
                          // },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        "4月": this.performancLevel1VO.othersForecastMonth4,
                        "5月": this.performancLevel1VO.othersForecastMonth5,
                        //  "6月": this.performancLevel1VO.othersForecastMonth6,
                        //   "7月": this.performancLevel1VO.othersForecastMonth7,
                        //   "8月": this.performancLevel1VO.othersForecastMonth8,
                        //   "9月": this.performancLevel1VO.othersForecastMonth9,
                        //   "10月": this.performancLevel1VO.othersForecastMonth10,
                        //   "11月": this.performancLevel1VO.othersForecastMonth11,
                        //   "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3,
                              this.performancLevel1VO.othersMonth4,
                               this.performancLevel1VO.othersMonth5];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3,
                               this.performancLevel1VO.othersSavingRateMonth4,
                               this.performancLevel1VO.othersSavingRateMonth5];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.othersCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.othersCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 5:
                   this.montharr=["1月","2月","3月","4月","5月","6月"];
                   this.montharr2=["7月","8月","9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          // {
                          // label: '7月',
                          // key: '7月'
                          // },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        "4月": this.performancLevel1VO.othersForecastMonth4,
                        "5月": this.performancLevel1VO.othersForecastMonth5,
                         "6月": this.performancLevel1VO.othersForecastMonth6,
                          // "7月": this.performancLevel1VO.othersForecastMonth7,
                          // "8月": this.performancLevel1VO.othersForecastMonth8,
                          // "9月": this.performancLevel1VO.othersForecastMonth9,
                          // "10月": this.performancLevel1VO.othersForecastMonth10,
                          // "11月": this.performancLevel1VO.othersForecastMonth11,
                          // "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3,
                              this.performancLevel1VO.othersMonth4,
                               this.performancLevel1VO.othersMonth5,
                               this.performancLevel1VO.othersMonth6];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3,
                               this.performancLevel1VO.othersSavingRateMonth4,
                               this.performancLevel1VO.othersSavingRateMonth5,
                               this.performancLevel1VO.othersSavingRateMonth6];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.othersCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.othersCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.othersCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 6:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月"];
                   this.montharr2=["8月","9月","10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          // {
                          // label: '8月',
                          // key: '8月'
                          // },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        "4月": this.performancLevel1VO.othersForecastMonth4,
                        "5月": this.performancLevel1VO.othersForecastMonth5,
                         "6月": this.performancLevel1VO.othersForecastMonth6,
                          "7月": this.performancLevel1VO.othersForecastMonth7,
                          // "8月": this.performancLevel1VO.othersForecastMonth8,
                          // "9月": this.performancLevel1VO.othersForecastMonth9,
                          // "10月": this.performancLevel1VO.othersForecastMonth10,
                          // "11月": this.performancLevel1VO.othersForecastMonth11,
                          // "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3,
                              this.performancLevel1VO.othersMonth4,
                               this.performancLevel1VO.othersMonth5,
                               this.performancLevel1VO.othersMonth6,
                               this.performancLevel1VO.othersMonth7];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3,
                               this.performancLevel1VO.othersSavingRateMonth4,
                               this.performancLevel1VO.othersSavingRateMonth5,
                               this.performancLevel1VO.othersSavingRateMonth6,
                                this.performancLevel1VO.othersSavingRateMonth7];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.othersCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.othersCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.othersCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.othersCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 7: 
                  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月"];
                   this.montharr2=["9月","10月","11月","12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          // {
                          // label: '9月',
                          // key: '9月'
                          // },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        "4月": this.performancLevel1VO.othersForecastMonth4,
                        "5月": this.performancLevel1VO.othersForecastMonth5,
                         "6月": this.performancLevel1VO.othersForecastMonth6,
                          "7月": this.performancLevel1VO.othersForecastMonth7,
                          "8月": this.performancLevel1VO.othersForecastMonth8,
                          // "9月": this.performancLevel1VO.othersForecastMonth9,
                          // "10月": this.performancLevel1VO.othersForecastMonth10,
                          // "11月": this.performancLevel1VO.othersForecastMonth11,
                          // "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3,
                              this.performancLevel1VO.othersMonth4,
                               this.performancLevel1VO.othersMonth5,
                               this.performancLevel1VO.othersMonth6,
                               this.performancLevel1VO.othersMonth7,
                                this.performancLevel1VO.othersMonth8];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3,
                               this.performancLevel1VO.othersSavingRateMonth4,
                               this.performancLevel1VO.othersSavingRateMonth5,
                               this.performancLevel1VO.othersSavingRateMonth6,
                                this.performancLevel1VO.othersSavingRateMonth7,
                                  this.performancLevel1VO.othersSavingRateMonth8];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.othersCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.othersCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.othersCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.othersCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.othersCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 8:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月"];
                   this.montharr2=["10月","11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          // {
                          // label: '10月',
                          // key: '10月'
                          // },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        "4月": this.performancLevel1VO.othersForecastMonth4,
                        "5月": this.performancLevel1VO.othersForecastMonth5,
                         "6月": this.performancLevel1VO.othersForecastMonth6,
                          "7月": this.performancLevel1VO.othersForecastMonth7,
                          "8月": this.performancLevel1VO.othersForecastMonth8,
                          "9月": this.performancLevel1VO.othersForecastMonth9,
                          // "10月": this.performancLevel1VO.othersForecastMonth10,
                          // "11月": this.performancLevel1VO.othersForecastMonth11,
                          // "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3,
                              this.performancLevel1VO.othersMonth4,
                               this.performancLevel1VO.othersMonth5,
                               this.performancLevel1VO.othersMonth6,
                               this.performancLevel1VO.othersMonth7,
                                this.performancLevel1VO.othersMonth8,
                                 this.performancLevel1VO.othersMonth9];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3,
                               this.performancLevel1VO.othersSavingRateMonth4,
                               this.performancLevel1VO.othersSavingRateMonth5,
                               this.performancLevel1VO.othersSavingRateMonth6,
                                this.performancLevel1VO.othersSavingRateMonth7,
                                  this.performancLevel1VO.othersSavingRateMonth8,
                                  this.performancLevel1VO.othersSavingRateMonth9];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.othersCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.othersCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.othersCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.othersCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.othersCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.othersCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 9:
                    this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月"];
                   this.montharr2=["11月","12月"];
                   this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          // {
                          // label: '11月',
                          // key: '11月'
                          // },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        "4月": this.performancLevel1VO.othersForecastMonth4,
                        "5月": this.performancLevel1VO.othersForecastMonth5,
                         "6月": this.performancLevel1VO.othersForecastMonth6,
                          "7月": this.performancLevel1VO.othersForecastMonth7,
                          "8月": this.performancLevel1VO.othersForecastMonth8,
                          "9月": this.performancLevel1VO.othersForecastMonth9,
                          "10月": this.performancLevel1VO.othersForecastMonth10,
                          // "11月": this.performancLevel1VO.othersForecastMonth11,
                          // "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3,
                              this.performancLevel1VO.othersMonth4,
                               this.performancLevel1VO.othersMonth5,
                               this.performancLevel1VO.othersMonth6,
                               this.performancLevel1VO.othersMonth7,
                                this.performancLevel1VO.othersMonth8,
                                 this.performancLevel1VO.othersMonth9,
                                 this.performancLevel1VO.othersMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3,
                               this.performancLevel1VO.othersSavingRateMonth4,
                               this.performancLevel1VO.othersSavingRateMonth5,
                               this.performancLevel1VO.othersSavingRateMonth6,
                                this.performancLevel1VO.othersSavingRateMonth7,
                                  this.performancLevel1VO.othersSavingRateMonth8,
                                  this.performancLevel1VO.othersSavingRateMonth9,
                                   this.performancLevel1VO.othersSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.othersCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.othersCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.othersCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.othersCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.othersCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.othersCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.othersCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 10:
                   this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月"];
                   this.montharr2=["12月"];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          // {
                          // label: '12月',
                          // key: '12月'
                          // },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        "4月": this.performancLevel1VO.othersForecastMonth4,
                        "5月": this.performancLevel1VO.othersForecastMonth5,
                         "6月": this.performancLevel1VO.othersForecastMonth6,
                          "7月": this.performancLevel1VO.othersForecastMonth7,
                          "8月": this.performancLevel1VO.othersForecastMonth8,
                          "9月": this.performancLevel1VO.othersForecastMonth9,
                          "10月": this.performancLevel1VO.othersForecastMonth10,
                          "11月": this.performancLevel1VO.othersForecastMonth11,
                          //"12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3,
                              this.performancLevel1VO.othersMonth4,
                               this.performancLevel1VO.othersMonth5,
                               this.performancLevel1VO.othersMonth6,
                               this.performancLevel1VO.othersMonth7,
                                this.performancLevel1VO.othersMonth8,
                                 this.performancLevel1VO.othersMonth9,
                                 this.performancLevel1VO.othersMonth10];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3,
                               this.performancLevel1VO.othersSavingRateMonth4,
                               this.performancLevel1VO.othersSavingRateMonth5,
                               this.performancLevel1VO.othersSavingRateMonth6,
                                this.performancLevel1VO.othersSavingRateMonth7,
                                  this.performancLevel1VO.othersSavingRateMonth8,
                                  this.performancLevel1VO.othersSavingRateMonth9,
                                   this.performancLevel1VO.othersSavingRateMonth10];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.othersCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.othersCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.othersCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.othersCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.othersCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.othersCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.othersCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
                case 11:
  this.montharr=["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
                   this.montharr2=[];
                    this.rightHeader=[
                          {
                          label: '1月',
                          key: '1月'
                          },
                           {
                          label: '2月',
                          key: '2月'
                          },
                          {
                          label: '3月',
                          key: '3月'
                          },
                          {
                          label: '4月',
                          key: '4月'
                          },
                          {
                          label: '5月',
                          key: '5月'
                          },
                          {
                          label: '6月',
                          key: '6月'
                          },
                          {
                          label: '7月',
                          key: '7月'
                          },
                          {
                          label: '8月',
                          key: '8月'
                          },
                          {
                          label: '9月',
                          key: '9月'
                          },
                          {
                          label: '10月',
                          key: '10月'
                          },
                          {
                          label: '11月',
                          key: '11月'
                          },
                          {
                          label: '12月',
                          key: '12月'
                          },
                  ];
                  this.rightsDate=[
                     {
                       "1月": this.performancLevel1VO.othersForecastMonth1,
                       "2月": this.performancLevel1VO.othersForecastMonth2,
                        "3月": this.performancLevel1VO.othersForecastMonth3,
                        "4月": this.performancLevel1VO.othersForecastMonth4,
                        "5月": this.performancLevel1VO.othersForecastMonth5,
                         "6月": this.performancLevel1VO.othersForecastMonth6,
                          "7月": this.performancLevel1VO.othersForecastMonth7,
                          "8月": this.performancLevel1VO.othersForecastMonth8,
                          "9月": this.performancLevel1VO.othersForecastMonth9,
                          "10月": this.performancLevel1VO.othersForecastMonth10,
                          "11月": this.performancLevel1VO.othersForecastMonth11,
                          "12月": this.performancLevel1VO.othersForecastMonth12,
                     }
                  ];
                    this.dataarr=[this.performancLevel1VO.othersMonth1,
                             this.performancLevel1VO.othersMonth2,
                             this.performancLevel1VO.othersMonth3,
                              this.performancLevel1VO.othersMonth4,
                               this.performancLevel1VO.othersMonth5,
                               this.performancLevel1VO.othersMonth6,
                               this.performancLevel1VO.othersMonth7,
                                this.performancLevel1VO.othersMonth8,
                                 this.performancLevel1VO.othersMonth9,
                                 this.performancLevel1VO.othersMonth10,
                                  this.performancLevel1VO.othersMonth11];//目标值
                    this.dataarr2=[this.performancLevel1VO.othersSavingRateMonth1,
                               this.performancLevel1VO.othersSavingRateMonth2,
                               this.performancLevel1VO.othersSavingRateMonth3,
                               this.performancLevel1VO.othersSavingRateMonth4,
                               this.performancLevel1VO.othersSavingRateMonth5,
                               this.performancLevel1VO.othersSavingRateMonth6,
                                this.performancLevel1VO.othersSavingRateMonth7,
                                  this.performancLevel1VO.othersSavingRateMonth8,
                                  this.performancLevel1VO.othersSavingRateMonth9,
                                   this.performancLevel1VO.othersSavingRateMonth10,
                                   this.performancLevel1VO.othersSavingRateMonth11];//实际值
                   this.tableData=[
                            {
                          date: '1月',
                          name: this.performancLevel1VO.othersCompletionMonth1,
                          //image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                          }, 
                          {
                            date: '2月',
                            name: this.performancLevel1VO.othersCompletionMonth2,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }, 
                            {
                            date: '3月',
                            name: this.performancLevel1VO.othersCompletionMonth3,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                            {
                            date: '4月',
                            name: this.performancLevel1VO.othersCompletionMonth4,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } ,
                             {
                            date: '5月',
                            name: this.performancLevel1VO.othersCompletionMonth5,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '6月',
                            name: this.performancLevel1VO.othersCompletionMonth6,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '7月',
                            name: this.performancLevel1VO.othersCompletionMonth7,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }   ,
                             {
                            date: '8月',
                            name: this.performancLevel1VO.othersCompletionMonth8,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '9月',
                            name: this.performancLevel1VO.othersCompletionMonth9,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '10月',
                            name: this.performancLevel1VO.othersCompletionMonth10,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            }  ,
                             {
                            date: '11月',
                            name: this.performancLevel1VO.othersCompletionMonth11,
                           // image: require('../../../../../../assets/common/performanc/icon/month/u3153.png')
                            } 
                       ];  
                             break;
             }
            // dataarr=
          }
       //   alert(this.dataarr[8]);
        //    alert(this.dataarr2[8]);
     
      return {
        title: {
          text: "",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "cross" },
        },
         color:['#00BFFF','#FFB90F'],
        legend: {
         // x: "right",
       //   right: 50,
         x: "center",
          y: "bottom",
         
         padding:[50,0,0,0], 
          data: ["目标节能","实际节能"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "7%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.montharr,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
            formatter: "{value} ",
            },
          },
        ],
        series: [
          {
            name: "目标节能",
            type: "bar",
            data: this.dataarr,
       // data: [,,,,,100,100,100,100],
          },
          {
            name: "实际节能",
            type: "bar",
           // data: [100,100,100,100,100,100,100,100,100],
            data: this.dataarr2,
            //  data: [this.performancLevel1VO.powerSavingRateMonth1,
            //       this.performancLevel1VO.powerSavingRateMonth2,
            //       this.performancLevel1VO.powerSavingRateMonth3,
          
            // ],
          },
         
        ],
      };
      
    },
   
     
   }
}
</script>
<style scoped src="../../../../../../assets/common/performanc/css/month/styles.css"></style>
<style scoped>
   @import "../../../../../../assets/common/consumption/css/styles.css";
   @import "../../../../../../assets/common/rp_page.css";
   
   /*--// 去掉表格单元格边框 */
.customer-table th{
    border:none;
    
  }
.customer-table td,.customer-table th.is-leaf {
  border:none;
}
  /*--/// 表格最外边框 */
.el-table--border, .el-table--group{
  border: none;
}
/*--/// // 头部边框 
.customer-table thead tr th.is-leaf{
  border: none;
  border-right: none;
}*/
.customer-table thead tr th:nth-last-of-type(2){
  border: none;
}
/*--/// // // 表格最外层边框-底部边框 */
.el-table--border::after, .el-table--group::after{
  width: 0;
}
.customer-table::before{
  width: 0;
}
.customer-table .el-table__fixed-right::before,.el-table__fixed::before{
  width: 0;
}

</style>
